// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { AdminUsersCreateData, AdminUsersCreateErrors, AdminUsersCreateResponses, AdminUsersDisableData, AdminUsersDisableErrors, AdminUsersDisableResponses, AdminUsersEnableData, AdminUsersEnableErrors, AdminUsersEnableResponses, AdminUsersListData, AdminUsersListErrors, AdminUsersListResponses, AdminUsersRemoveRoomRoleData, AdminUsersRemoveRoomRoleErrors, AdminUsersRemoveRoomRoleResponses, AdminUsersSetRoomRoleData, AdminUsersSetRoomRoleErrors, AdminUsersSetRoomRoleResponses, AdminUsersUpdateData, AdminUsersUpdateErrors, AdminUsersUpdateResponses, ApiKeysCreateData, ApiKeysCreateErrors, ApiKeysCreateResponses, ApiKeysListData, ApiKeysListErrors, ApiKeysListResponses, ApiKeysRevokeData, ApiKeysRevokeErrors, ApiKeysRevokeResponses, AttachmentsCompleteData, AttachmentsCompleteErrors, AttachmentsCompleteResponses, AttachmentsPresignData, AttachmentsPresignErrors, AttachmentsPresignResponses, BeforeUserCreatedCheckData, BeforeUserCreatedCheckErrors, BeforeUserCreatedCheckResponses, ConfigGetData, ConfigGetErrors, ConfigGetResponses, DeletionsGetData, DeletionsGetErrors, DeletionsGetResponses, EventsSendData, EventsSendErrors, EventsSendResponses, HandoffsCreateData, HandoffsCreateErrors, HandoffsCreateResponses, HandoffsGetData, HandoffsGetErrors, HandoffsGetResponses, HypothesesAcceptOwnershipData, HypothesesAcceptOwnershipErrors, HypothesesAcceptOwnershipResponses, HypothesesAddEvidenceData, HypothesesAddEvidenceErrors, HypothesesAddEvidenceResponses, HypothesesAddExternalLinkData, HypothesesAddExternalLinkErrors, HypothesesAddExternalLinkResponses, HypothesesAddFindingData, HypothesesAddFindingErrors, HypothesesAddFindingResponses, HypothesesAddNoteData, HypothesesAddNoteErrors, HypothesesAddNoteResponses, HypothesesAdjustData, HypothesesAdjustErrors, HypothesesAdjustResponses, HypothesesApproveAdjustmentData, HypothesesApproveAdjustmentErrors, HypothesesApproveAdjustmentResponses, HypothesesAssignData, HypothesesAssignErrors, HypothesesAssignResponses, HypothesesConcludeData, HypothesesConcludeErrors, HypothesesConcludeResponses, HypothesesConfigData, HypothesesConfigErrors, HypothesesConfigResponses, HypothesesConfirmConclusionData, HypothesesConfirmConclusionErrors, HypothesesConfirmConclusionResponses, HypothesesCountsData, HypothesesCountsErrors, HypothesesCountsResponses, HypothesesCreateData, HypothesesCreateErrors, HypothesesCreateProgramData, HypothesesCreateProgramErrors, HypothesesCreateProgramResponses, HypothesesCreateResponses, HypothesesDeclineAdjustmentData, HypothesesDeclineAdjustmentErrors, HypothesesDeclineAdjustmentResponses, HypothesesDeclineOwnershipData, HypothesesDeclineOwnershipErrors, HypothesesDeclineOwnershipResponses, HypothesesExportOnePageData, HypothesesExportOnePageErrors, HypothesesExportOnePageResponses, HypothesesGetData, HypothesesGetErrors, HypothesesGetResponses, HypothesesListData, HypothesesListErrors, HypothesesListEvidenceData, HypothesesListEvidenceErrors, HypothesesListEvidenceResponses, HypothesesListNotesData, HypothesesListNotesErrors, HypothesesListNotesResponses, HypothesesListProgramsData, HypothesesListProgramsErrors, HypothesesListProgramsResponses, HypothesesListResponses, HypothesesMeasurementReadyData, HypothesesMeasurementReadyErrors, HypothesesMeasurementReadyResponses, HypothesesNeedsMoreData, HypothesesNeedsMoreErrors, HypothesesNeedsMoreResponses, HypothesesOverrideData, HypothesesOverrideErrors, HypothesesOverrideResponses, HypothesesParkData, HypothesesParkErrors, HypothesesParkResponses, HypothesesPauseData, HypothesesPauseErrors, HypothesesPauseResponses, HypothesesRejectData, HypothesesRejectErrors, HypothesesRejectResponses, HypothesesRemoveEvidenceData, HypothesesRemoveEvidenceErrors, HypothesesRemoveEvidenceResponses, HypothesesRemoveExternalLinkData, HypothesesRemoveExternalLinkErrors, HypothesesRemoveExternalLinkResponses, HypothesesResumeData, HypothesesResumeErrors, HypothesesResumeResponses, HypothesesSelectData, HypothesesSelectErrors, HypothesesSelectResponses, HypothesesSendBackConclusionData, HypothesesSendBackConclusionErrors, HypothesesSendBackConclusionResponses, HypothesesSendConclusionNoticeData, HypothesesSendConclusionNoticeErrors, HypothesesSendConclusionNoticeResponses, HypothesesShortenDeadlineData, HypothesesShortenDeadlineErrors, HypothesesShortenDeadlineResponses, HypothesesSkipConclusionNoticeData, HypothesesSkipConclusionNoticeErrors, HypothesesSkipConclusionNoticeResponses, HypothesesStartData, HypothesesStartErrors, HypothesesStartResponses, HypothesesStartReviewData, HypothesesStartReviewErrors, HypothesesStartReviewResponses, HypothesesStopData, HypothesesStopErrors, HypothesesStopResponses, HypothesesSubmitData, HypothesesSubmitErrors, HypothesesSubmitResponses, HypothesesUnparkData, HypothesesUnparkErrors, HypothesesUnparkResponses, HypothesesUpdateData, HypothesesUpdateErrors, HypothesesUpdateResponses, HypothesesVerifySourceData, HypothesesVerifySourceErrors, HypothesesVerifySourceResponses, HypothesesWithdrawData, HypothesesWithdrawErrors, HypothesesWithdrawResponses, HypothesisInterestAcknowledgeWatchData, HypothesisInterestAcknowledgeWatchErrors, HypothesisInterestAcknowledgeWatchResponses, HypothesisInterestDeleteDataPointerData, HypothesisInterestDeleteDataPointerErrors, HypothesisInterestDeleteDataPointerResponses, HypothesisInterestPutDataPointerData, HypothesisInterestPutDataPointerErrors, HypothesisInterestPutDataPointerResponses, HypothesisInterestUnwatchData, HypothesisInterestUnwatchErrors, HypothesisInterestUnwatchResponses, HypothesisInterestWatchData, HypothesisInterestWatchErrors, HypothesisInterestWatchResponses, HypothesisMeetingLogMeetingsData, HypothesisMeetingLogMeetingsErrors, HypothesisMeetingLogMeetingsResponses, HypothesisMeetingsAddItemData, HypothesisMeetingsAddItemErrors, HypothesisMeetingsAddItemResponses, HypothesisMeetingsCancelData, HypothesisMeetingsCancelErrors, HypothesisMeetingsCancelResponses, HypothesisMeetingsChangeDecisionData, HypothesisMeetingsChangeDecisionErrors, HypothesisMeetingsChangeDecisionResponses, HypothesisMeetingsConfirmData, HypothesisMeetingsConfirmErrors, HypothesisMeetingsConfirmResponses, HypothesisMeetingsCountsData, HypothesisMeetingsCountsErrors, HypothesisMeetingsCountsResponses, HypothesisMeetingsCreateData, HypothesisMeetingsCreateErrors, HypothesisMeetingsCreateResponses, HypothesisMeetingsEndData, HypothesisMeetingsEndErrors, HypothesisMeetingsEndResponses, HypothesisMeetingsGetData, HypothesisMeetingsGetErrors, HypothesisMeetingsGetResponses, HypothesisMeetingsHandOverData, HypothesisMeetingsHandOverErrors, HypothesisMeetingsHandOverItemData, HypothesisMeetingsHandOverItemErrors, HypothesisMeetingsHandOverItemResponses, HypothesisMeetingsHandOverResponses, HypothesisMeetingsListData, HypothesisMeetingsListErrors, HypothesisMeetingsListResponses, HypothesisMeetingsRegisterData, HypothesisMeetingsRegisterErrors, HypothesisMeetingsRegisterResponses, HypothesisMeetingsRemoveItemData, HypothesisMeetingsRemoveItemErrors, HypothesisMeetingsRemoveItemResponses, HypothesisMeetingsReorderData, HypothesisMeetingsReorderErrors, HypothesisMeetingsReorderResponses, HypothesisMeetingsScreenData, HypothesisMeetingsScreenErrors, HypothesisMeetingsScreenResponses, HypothesisMeetingsStartData, HypothesisMeetingsStartErrors, HypothesisMeetingsStartResponses, HypothesisMeetingsUpdateData, HypothesisMeetingsUpdateErrors, HypothesisMeetingsUpdateItemData, HypothesisMeetingsUpdateItemErrors, HypothesisMeetingsUpdateItemResponses, HypothesisMeetingsUpdateResponses, HypothesisMeetingsWriteReasonData, HypothesisMeetingsWriteReasonErrors, HypothesisMeetingsWriteReasonResponses, HypothesisMemoryMergeCandidatesData, HypothesisMemoryMergeCandidatesErrors, HypothesisMemoryMergeCandidatesResponses, HypothesisMemoryMergeData, HypothesisMemoryMergeErrors, HypothesisMemoryMergeResponses, HypothesisMemoryMetricExamplesData, HypothesisMemoryMetricExamplesErrors, HypothesisMemoryMetricExamplesResponses, HypothesisMemorySimilarData, HypothesisMemorySimilarErrors, HypothesisMemorySimilarResponses, HypothesisSourceQuestionsAnswerData, HypothesisSourceQuestionsAnswerErrors, HypothesisSourceQuestionsAnswerResponses, HypothesisSourceQuestionsAskData, HypothesisSourceQuestionsAskErrors, HypothesisSourceQuestionsAskResponses, HypothesisSourceQuestionsCloseQuestionData, HypothesisSourceQuestionsCloseQuestionErrors, HypothesisSourceQuestionsCloseQuestionResponses, HypothesisSourceQuestionsDecideData, HypothesisSourceQuestionsDecideErrors, HypothesisSourceQuestionsDecideResponses, HypothesisSourceQuestionsGetQuestionData, HypothesisSourceQuestionsGetQuestionErrors, HypothesisSourceQuestionsGetQuestionResponses, HypothesisSourceQuestionsListQuestionsData, HypothesisSourceQuestionsListQuestionsErrors, HypothesisSourceQuestionsListQuestionsResponses, HypothesisSourcesArchiveData, HypothesisSourcesArchiveErrors, HypothesisSourcesArchiveResponses, HypothesisSourcesCreateData, HypothesisSourcesCreateErrors, HypothesisSourcesCreateResponses, HypothesisSourcesGetData, HypothesisSourcesGetErrors, HypothesisSourcesGetResponses, HypothesisSourcesListData, HypothesisSourcesListErrors, HypothesisSourcesListResponses, HypothesisSourcesUpdateData, HypothesisSourcesUpdateErrors, HypothesisSourcesUpdateResponses, KnownIssuesConfirmData, KnownIssuesConfirmErrors, KnownIssuesConfirmResponses, KnownIssuesCreateData, KnownIssuesCreateErrors, KnownIssuesCreateResponses, KnownIssuesGetData, KnownIssuesGetErrors, KnownIssuesGetResponses, KnownIssuesList2Data, KnownIssuesList2Errors, KnownIssuesList2Responses, KnownIssuesListData, KnownIssuesListErrors, KnownIssuesListResponses, KnownIssuesUpdateData, KnownIssuesUpdateErrors, KnownIssuesUpdateResponses, MeGetData, MeGetErrors, MeGetResponses, MeUpdateData, MeUpdateErrors, MeUpdateResponses, ProductsCreateData, ProductsCreateErrors, ProductsCreateResponses, ProductsListData, ProductsListErrors, ProductsListResponses, ProductsRevokeKeyData, ProductsRevokeKeyErrors, ProductsRevokeKeyResponses, ProductsRotateKeyData, ProductsRotateKeyErrors, ProductsRotateKeyResponses, ProductsUpdateData, ProductsUpdateErrors, ProductsUpdateResponses, ProgramsAcceptData, ProgramsAcceptErrors, ProgramsAcceptResponses, ProgramsCloseData, ProgramsCloseErrors, ProgramsCloseResponses, ProgramsCompleteTaskData, ProgramsCompleteTaskErrors, ProgramsCompleteTaskResponses, ProgramsCreateData, ProgramsCreateErrors, ProgramsCreateResponses, ProgramsDeclineData, ProgramsDeclineErrors, ProgramsDeclineResponses, ProgramsFlagConfirmedData, ProgramsFlagConfirmedErrors, ProgramsFlagConfirmedResponses, ProgramsGetData, ProgramsGetErrors, ProgramsGetReportData, ProgramsGetReportErrors, ProgramsGetReportResponses, ProgramsGetResponses, ProgramsInviteData, ProgramsInviteErrors, ProgramsInviteResponses, ProgramsListData, ProgramsListErrors, ProgramsListInvitationsData, ProgramsListInvitationsErrors, ProgramsListInvitationsResponses, ProgramsListMineData, ProgramsListMineErrors, ProgramsListMineResponses, ProgramsListParticipantsData, ProgramsListParticipantsErrors, ProgramsListParticipantsResponses, ProgramsListResponses, ProgramsReportData, ProgramsReportErrors, ProgramsReportResponses, ProgramsRespondData, ProgramsRespondErrors, ProgramsRespondResponses, ProgramsSegmentData, ProgramsSegmentErrors, ProgramsSegmentResponses, ProgramsUpdateData, ProgramsUpdateErrors, ProgramsUpdateResponses, ProgramsWithdrawData, ProgramsWithdrawErrors, ProgramsWithdrawResponses, SessionGetData, SessionGetErrors, SessionGetResponses, SettingsGetData, SettingsGetErrors, SettingsGetResponses, SettingsUpdateData, SettingsUpdateErrors, SettingsUpdateResponses, StatsGetData, StatsGetErrors, StatsGetResponses, SubjectsRemoveData, SubjectsRemoveErrors, SubjectsRemoveResponses, SubmissionsAddAddendumData, SubmissionsAddAddendumErrors, SubmissionsAddAddendumResponses, SubmissionsAddNoteData, SubmissionsAddNoteErrors, SubmissionsAddNoteResponses, SubmissionsAttachmentUrlData, SubmissionsAttachmentUrlErrors, SubmissionsAttachmentUrlResponses, SubmissionsCountsData, SubmissionsCountsErrors, SubmissionsCountsResponses, SubmissionsCreateData, SubmissionsCreateErrors, SubmissionsCreateResponses, SubmissionsGetData, SubmissionsGetErrors, SubmissionsGetResponses, SubmissionsListData, SubmissionsListErrors, SubmissionsListMineData, SubmissionsListMineErrors, SubmissionsListMineResponses, SubmissionsListResponses, SubmissionsRemoveAttachmentData, SubmissionsRemoveAttachmentErrors, SubmissionsRemoveAttachmentResponses, SubmissionsStatusData, SubmissionsStatusErrors, SubmissionsStatusResponses, SubmissionsUpdateData, SubmissionsUpdateErrors, SubmissionsUpdateResponses, SubmissionsUpdateStatusData, SubmissionsUpdateStatusErrors, SubmissionsUpdateStatusResponses, WebhooksCreateData, WebhooksCreateErrors, WebhooksCreateResponses, WebhooksGetData, WebhooksGetErrors, WebhooksGetResponses, WebhooksListData, WebhooksListDeliveriesData, WebhooksListDeliveriesErrors, WebhooksListDeliveriesResponses, WebhooksListErrors, WebhooksListResponses, WebhooksRemoveData, WebhooksRemoveErrors, WebhooksRemoveResponses, WebhooksRetryDeliveryData, WebhooksRetryDeliveryErrors, WebhooksRetryDeliveryResponses, WebhooksRotateSecretData, WebhooksRotateSecretErrors, WebhooksRotateSecretResponses, WebhooksTestData, WebhooksTestErrors, WebhooksTestResponses, WebhooksUpdateData, WebhooksUpdateErrors, WebhooksUpdateResponses, WebhooksVerifyData, WebhooksVerifyErrors, WebhooksVerifyResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * ApiKeys for the Tenant surface, without plaintext.
 */
export const apiKeysList = <ThrowOnError extends boolean = false>(options?: Options<ApiKeysListData, ThrowOnError>): RequestResult<ApiKeysListResponses, ApiKeysListErrors, ThrowOnError> => (options?.client ?? client).get<ApiKeysListResponses, ApiKeysListErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/api-keys',
    ...options
});

/**
 * Creates a scoped ApiKey. The plaintext exists only in this response (DD-20).
 */
export const apiKeysCreate = <ThrowOnError extends boolean = false>(options: Options<ApiKeysCreateData, ThrowOnError>): RequestResult<ApiKeysCreateResponses, ApiKeysCreateErrors, ThrowOnError> => (options.client ?? client).post<ApiKeysCreateResponses, ApiKeysCreateErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/api-keys',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revokes.
 */
export const apiKeysRevoke = <ThrowOnError extends boolean = false>(options: Options<ApiKeysRevokeData, ThrowOnError>): RequestResult<ApiKeysRevokeResponses, ApiKeysRevokeErrors, ThrowOnError> => (options.client ?? client).delete<ApiKeysRevokeResponses, ApiKeysRevokeErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/api-keys/{id}',
    ...options
});

/**
 * The register, the inbox, «Mine hypoteser» (My hypotheses — mine) and «Til deg» (For you — assignedToMe, without final statuses, the same set that requiresYou counts). Without a filter: everything except others' drafts. Sorting with sort = frist (default): «Avgjør nå» (Decide now) first, then «Hva mister vi hvis vi venter?» (What do we lose by waiting?) set, then without activity, then oldest first (H6). sort = nyest: descending submitted time, without rank (DD-74). sort = impact, confidence or effort: one number from the decision meeting, only while «Menneskesatte tall» is on (422 score_sort_disabled), and only on the numbers the caller may see — the rules on HypothesisListSort (H3.2). Drafts are shown only to the submitter.
 */
export const hypothesesList = <ThrowOnError extends boolean = false>(options?: Options<HypothesesListData, ThrowOnError>): RequestResult<HypothesesListResponses, HypothesesListErrors, ThrowOnError> => (options?.client ?? client).get<HypothesesListResponses, HypothesesListErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses',
    ...options
});

/**
 * Creates a draft on the first save — empty or half-written. The caller is the submitter, named from the first save. The draft lives on the server (no localStorage, K8) and is deleted after 180 days without changes. No gates, but a threshold that is not a number gives 422 threshold_not_numeric, as with PATCH and adjust. No audit row before «Send inn» (Submit).
 */
export const hypothesesCreate = <ThrowOnError extends boolean = false>(options: Options<HypothesesCreateData, ThrowOnError>): RequestResult<HypothesesCreateResponses, HypothesesCreateErrors, ThrowOnError> => (options.client ?? client).post<HypothesesCreateResponses, HypothesesCreateErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The room's wording, deadlines, minimums, deciders and help text — what the submission flow needs, readable for bidragsyter. TenantSettings is behind innspill:leser and carries more than an employee should see.
 */
export const hypothesesConfig = <ThrowOnError extends boolean = false>(options?: Options<HypothesesConfigData, ThrowOnError>): RequestResult<HypothesesConfigResponses, HypothesesConfigErrors, ThrowOnError> => (options?.client ?? client).get<HypothesesConfigResponses, HypothesesConfigErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/config',
    ...options
});

/**
 * The count line above the register and the top of the inbox (H20, DD-01), and the badge on «Til deg» (requiresYou, per caller). Computed on lookup; others' drafts are never counted.
 */
export const hypothesesCounts = <ThrowOnError extends boolean = false>(options?: Options<HypothesesCountsData, ThrowOnError>): RequestResult<HypothesesCountsResponses, HypothesesCountsErrors, ThrowOnError> => (options?.client ?? client).get<HypothesesCountsResponses, HypothesesCountsErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/counts',
    ...options
});

/**
 * «Møter» (W1) and the meeting part of «Til deg» (W9). planlagt by heldOn ascending first, then the others by heldOn descending. leser and up see every meeting; a contributor sees only the meetings she decides. No filter on a person (Kh8). Writes no audit row.
 */
export const hypothesisMeetingsList = <ThrowOnError extends boolean = false>(options?: Options<HypothesisMeetingsListData, ThrowOnError>): RequestResult<HypothesisMeetingsListResponses, HypothesisMeetingsListErrors, ThrowOnError> => (options?.client ?? client).get<HypothesisMeetingsListResponses, HypothesisMeetingsListErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/meetings',
    ...options
});

/**
 * «Nytt møte» (W2). The caller becomes the registrar and must have set her display name (409 display_name_missing). The decider from the list (422 decider_not_on_list). Status planlagt, empty agenda. AuditEntry hypothesis_meeting.created (ids, never the name).
 */
export const hypothesisMeetingsCreate = <ThrowOnError extends boolean = false>(options: Options<HypothesisMeetingsCreateData, ThrowOnError>): RequestResult<HypothesisMeetingsCreateResponses, HypothesisMeetingsCreateErrors, ThrowOnError> => (options.client ?? client).post<HypothesisMeetingsCreateResponses, HypothesisMeetingsCreateErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/meetings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The number by «Møter» and the meeting part of the «Til deg» badge, per caller (DecisionMeetingCounts). Computed on lookup.
 */
export const hypothesisMeetingsCounts = <ThrowOnError extends boolean = false>(options?: Options<HypothesisMeetingsCountsData, ThrowOnError>): RequestResult<HypothesisMeetingsCountsResponses, HypothesisMeetingsCountsErrors, ThrowOnError> => (options?.client ?? client).get<HypothesisMeetingsCountsResponses, HypothesisMeetingsCountsErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/meetings/counts',
    ...options
});

/**
 * «Avlys møtet …» (cancel the meeting, W1): deletes the meeting, its rows, the registrations, the notes and the numbers that were not confirmed. No hypothesis changes — nothing has happened before confirmation. Only the registrar (403 not_meeting_registrar), only in planlagt, also while it runs (409 meeting_locked after «Avslutt møtet»). 204. AuditEntry hypothesis_meeting.cancelled.
 */
export const hypothesisMeetingsCancel = <ThrowOnError extends boolean = false>(options: Options<HypothesisMeetingsCancelData, ThrowOnError>): RequestResult<HypothesisMeetingsCancelResponses, HypothesisMeetingsCancelErrors, ThrowOnError> => (options.client ?? client).delete<HypothesisMeetingsCancelResponses, HypothesisMeetingsCancelErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/meetings/{meetingId}',
    ...options
});

/**
 * The meeting with the agenda, the rows and the timeline — the agenda (W1), the run (W5), the confirmation (W9) and the decision log (W11) are this one read. leser and up, or the meeting's decider (403 insufficient_role for a contributor who is neither). The registrar's note only to the registrar; the numbers only to leser and up and the decider, and only while «Menneskesatte tall» is on; quote ids only to a caller who can see the cases. Writes no audit row (Kh9).
 */
export const hypothesisMeetingsGet = <ThrowOnError extends boolean = false>(options: Options<HypothesisMeetingsGetData, ThrowOnError>): RequestResult<HypothesisMeetingsGetResponses, HypothesisMeetingsGetErrors, ThrowOnError> => (options.client ?? client).get<HypothesisMeetingsGetResponses, HypothesisMeetingsGetErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/meetings/{meetingId}',
    ...options
});

/**
 * «Endre dato eller beslutningstaker» (change date or decider), and the name. Only the registrar (403 not_meeting_registrar), only in planlagt (409 meeting_locked). A new decider: 422 decider_not_on_list, 422 decider_is_submitter. AuditEntry hypothesis_meeting.updated.
 */
export const hypothesisMeetingsUpdate = <ThrowOnError extends boolean = false>(options: Options<HypothesisMeetingsUpdateData, ThrowOnError>): RequestResult<HypothesisMeetingsUpdateResponses, HypothesisMeetingsUpdateErrors, ThrowOnError> => (options.client ?? client).patch<HypothesisMeetingsUpdateResponses, HypothesisMeetingsUpdateErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/meetings/{meetingId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * «Bekreft alle» (confirm all, W9, W10): the ONE call that makes the meeting's decisions happen — every row, or none. Only the meeting's decider (403 not_decider), who must still be on the tenant's list (403 not_decider); only in venter_bekreftelse (409 meeting_not_awaiting_confirmation — also when it was confirmed from another device, W10b: nothing happens twice).
 *
 * In one transaction, per row by the effective outcome (decision, otherwise registered):
 * - left vurderes since (withdrawn, parked or selected by someone else): tatt_ut, nothing happens;
 * - velg: transition 6 with the owner and the reply — the decider becomes the hypothesis's decider; the gates of select apply (422 owner_is_decider, 422 decider_is_submitter);
 * - parker: transition 4 with revisitAt — counted again from today (422 revisit_date_out_of_range) — and the reply;
 * - avvis with a reply: transition 3 with the code (422 template_unmodified), and with vurdert_for the earlier hypothesis on the transition (relatedHypothesis — 422 related_hypothesis_required when it is no longer konkludert or stoppet);
 * - avvis without a reply: NO transition; the row is venter_begrunnelse, the hypothesis stays in vurderes with its deadline, and the lock stays (P10). The deadline warning for it goes to the registrar (P8); the deadline is never extended;
 * - ikke_i_dag: nothing; the hypothesis stays in vurderes with its deadline.
 * A gate that fails on one row fails the call with that hypothesis's number in the message, and nothing happens — half a list never goes out. Each transition carries by = the decider, registeredBy = the registrar and meeting (HypothesisTransition), and its reply; the numbers on each row become a HypothesisScore. Status bekreftet. AuditEntry hypothesis_meeting.confirmed, and hypothesis.status_changed per transition and hypothesis.score_set per score, as for direct decisions.
 */
export const hypothesisMeetingsConfirm = <ThrowOnError extends boolean = false>(options: Options<HypothesisMeetingsConfirmData, ThrowOnError>): RequestResult<HypothesisMeetingsConfirmResponses, HypothesisMeetingsConfirmErrors, ThrowOnError> => (options.client ?? client).post<HypothesisMeetingsConfirmResponses, HypothesisMeetingsConfirmErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/meetings/{meetingId}/confirm',
    ...options
});

/**
 * «Avslutt møtet» — «Avslutt og send til Rune Aas» (W8). Only the registrar (403 not_meeting_registrar), only while it runs (409 meeting_not_started, 409 meeting_locked). In one transaction: every row without an outcome gets ikke_i_dag (the dialog names them before); rows that left vurderes become tatt_ut; a row whose outcome lacks what it needs gives 409 registration_incomplete with the hypothesis numbers in the message, and nothing is saved. The registrations are frozen as registered, status venter_bekreftelse, sentAt is set, and the meeting is in the decider's «Til deg». Still no transition and nothing to any submitter. AuditEntry hypothesis_meeting.sent (counts per outcome, never text). The event hypothesis.meeting_to_confirm comes with H3.5.
 */
export const hypothesisMeetingsEnd = <ThrowOnError extends boolean = false>(options: Options<HypothesisMeetingsEndData, ThrowOnError>): RequestResult<HypothesisMeetingsEndResponses, HypothesisMeetingsEndErrors, ThrowOnError> => (options.client ?? client).post<HypothesisMeetingsEndResponses, HypothesisMeetingsEndErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/meetings/{meetingId}/end',
    ...options
});

/**
 * «Gi hele møtet videre …» (hand the whole meeting on): a new decider for the meeting, which stays in venter_bekreftelse and moves to the new decider's «Til deg». Only the meeting's decider (403 not_decider), or eier while he is deactivated; only in venter_bekreftelse (409 meeting_not_awaiting_confirmation). Rules on MeetingHandOverRequest. AuditEntry hypothesis_meeting.handed_over.
 */
export const hypothesisMeetingsHandOver = <ThrowOnError extends boolean = false>(options: Options<HypothesisMeetingsHandOverData, ThrowOnError>): RequestResult<HypothesisMeetingsHandOverResponses, HypothesisMeetingsHandOverErrors, ThrowOnError> => (options.client ?? client).post<HypothesisMeetingsHandOverResponses, HypothesisMeetingsHandOverErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/meetings/{meetingId}/hand-over',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * «Legg til hypotese …» (L): puts a hypothesis on the agenda, last. behandler in the room (or eier) — the agenda is the reviewers'. Only in planlagt (409 meeting_locked). The hypothesis must be in vurderes (409 not_in_review) and not on the agenda of a meeting that is not confirmed — this one or another (409 already_on_agenda). The meeting's decider cannot be its submitter or a co-submitter (422 decider_is_submitter) — checked here, not at confirmation (W2). Unknown hypothesis or another tenant's: 404 hypothesis_not_found. AuditEntry hypothesis_meeting.item_added.
 */
export const hypothesisMeetingsAddItem = <ThrowOnError extends boolean = false>(options: Options<HypothesisMeetingsAddItemData, ThrowOnError>): RequestResult<HypothesisMeetingsAddItemResponses, HypothesisMeetingsAddItemErrors, ThrowOnError> => (options.client ?? client).post<HypothesisMeetingsAddItemResponses, HypothesisMeetingsAddItemErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/meetings/{meetingId}/items',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * «Fjern fra agendaen» (remove from the agenda). behandler in the room (or eier), only in planlagt (409 meeting_locked). The registration, the note and the numbers on the row go with it. 404 meeting_item_not_found. AuditEntry hypothesis_meeting.item_removed.
 */
export const hypothesisMeetingsRemoveItem = <ThrowOnError extends boolean = false>(options: Options<HypothesisMeetingsRemoveItemData, ThrowOnError>): RequestResult<HypothesisMeetingsRemoveItemResponses, HypothesisMeetingsRemoveItemErrors, ThrowOnError> => (options.client ?? client).delete<HypothesisMeetingsRemoveItemResponses, HypothesisMeetingsRemoveItemErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/meetings/{meetingId}/items/{hypothesisId}',
    ...options
});

/**
 * The agenda row before the meeting: recommendation (signed by the caller, display name required — 409 display_name_missing), proposed owner and quotes (W1, W3). behandler in the room (or eier); the quotes in addition require access to the cases (403 insufficient_role, rules on DecisionMeetingItemUpdate). Only in planlagt (409 meeting_locked). Not on the agenda: 404 meeting_item_not_found. AuditEntry hypothesis_meeting.item_changed; choosing quotes also gives hypothesis_meeting.quotes_chosen with the case ids — never the text.
 */
export const hypothesisMeetingsUpdateItem = <ThrowOnError extends boolean = false>(options: Options<HypothesisMeetingsUpdateItemData, ThrowOnError>): RequestResult<HypothesisMeetingsUpdateItemResponses, HypothesisMeetingsUpdateItemErrors, ThrowOnError> => (options.client ?? client).patch<HypothesisMeetingsUpdateItemResponses, HypothesisMeetingsUpdateItemErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/meetings/{meetingId}/items/{hypothesisId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * «Endre» (change) on one row before confirmation (W9). Only the meeting's decider (403 not_decider), only in venter_bekreftelse (409 meeting_not_awaiting_confirmation), only a row that is registrert (409 not_in_review when it is tatt_ut). Rules on MeetingDecisionUpdate. AuditEntry hypothesis_meeting.item_changed_by_decider (the outcomes, never text).
 */
export const hypothesisMeetingsChangeDecision = <ThrowOnError extends boolean = false>(options: Options<HypothesisMeetingsChangeDecisionData, ThrowOnError>): RequestResult<HypothesisMeetingsChangeDecisionResponses, HypothesisMeetingsChangeDecisionErrors, ThrowOnError> => (options.client ?? client).patch<HypothesisMeetingsChangeDecisionResponses, HypothesisMeetingsChangeDecisionErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/meetings/{meetingId}/items/{hypothesisId}/decision',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * «Gi videre …» on one row (W9): the row is handed to another decider and moves to a new meeting with the same name, date and registrar, in venter_bekreftelse with the registration as it stands; this row becomes gitt_videre. Only the meeting's decider (403 not_decider), or eier while he is deactivated; only in venter_bekreftelse (409 meeting_not_awaiting_confirmation). Rules on MeetingHandOverRequest. The response is this meeting. AuditEntry hypothesis_meeting.handed_over.
 */
export const hypothesisMeetingsHandOverItem = <ThrowOnError extends boolean = false>(options: Options<HypothesisMeetingsHandOverItemData, ThrowOnError>): RequestResult<HypothesisMeetingsHandOverItemResponses, HypothesisMeetingsHandOverItemErrors, ThrowOnError> => (options.client ?? client).post<HypothesisMeetingsHandOverItemResponses, HypothesisMeetingsHandOverItemErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/meetings/{meetingId}/items/{hypothesisId}/hand-over',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * «Skriv begrunnelsen for H-128 …» (write the justification, W11): the reply for a confirmed avvis that waited. The registrar or the meeting's decider (403 not_meeting_registrar); only a row that is venter_begrunnelse (409 reason_not_pending). The hypothesis must still be in vurderes — otherwise the row becomes tatt_ut (409 not_in_review). The transition to avvist happens now: by = the decider who confirmed, registeredBy = the registrar, meeting set, with the reply (422 template_unmodified). The lock on the submitter ends. AuditEntry hypothesis.status_changed.
 */
export const hypothesisMeetingsWriteReason = <ThrowOnError extends boolean = false>(options: Options<HypothesisMeetingsWriteReasonData, ThrowOnError>): RequestResult<HypothesisMeetingsWriteReasonResponses, HypothesisMeetingsWriteReasonErrors, ThrowOnError> => (options.client ?? client).post<HypothesisMeetingsWriteReasonResponses, HypothesisMeetingsWriteReasonErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/meetings/{meetingId}/items/{hypothesisId}/reason',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The run (W5): registers the outcome, the owner, the reply, the numbers and the note on one row, on the decider's behalf. Saved at once; NOTHING happens to the hypothesis and nobody is told. Only the registrar (403 not_meeting_registrar), only while the meeting runs — started and not ended (409 meeting_not_started, 409 meeting_locked). The row must still be in vurderes (409 not_in_review — it is shown as tatt_ut). Field rules on MeetingRegistrationUpdate. No audit row per press — the run is a draft; the list is audited when the meeting ends.
 */
export const hypothesisMeetingsRegister = <ThrowOnError extends boolean = false>(options: Options<HypothesisMeetingsRegisterData, ThrowOnError>): RequestResult<HypothesisMeetingsRegisterResponses, HypothesisMeetingsRegisterErrors, ThrowOnError> => (options.client ?? client).patch<HypothesisMeetingsRegisterResponses, HypothesisMeetingsRegisterErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/meetings/{meetingId}/items/{hypothesisId}/registration',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The order of the agenda (drag, or Alt ↑/Alt ↓). behandler in the room (or eier), only in planlagt (409 meeting_locked); every row exactly once (422 validation_failed). No audit row — the order is presentation, not a decision.
 */
export const hypothesisMeetingsReorder = <ThrowOnError extends boolean = false>(options: Options<HypothesisMeetingsReorderData, ThrowOnError>): RequestResult<HypothesisMeetingsReorderResponses, HypothesisMeetingsReorderErrors, ThrowOnError> => (options.client ?? client).put<HypothesisMeetingsReorderResponses, HypothesisMeetingsReorderErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/meetings/{meetingId}/order',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * «Skjermen i rommet» (the screen in the room, W6, W7): the closed read model for the wall — never the numbers, never notes, never replies (MeetingScreen). leser and up, or the meeting's decider (403 insufficient_role), in every status — a confirmed meeting can be shown again (W11). Quotes only for a caller who can see the cases. Writes no audit row (Kh9).
 */
export const hypothesisMeetingsScreen = <ThrowOnError extends boolean = false>(options: Options<HypothesisMeetingsScreenData, ThrowOnError>): RequestResult<HypothesisMeetingsScreenResponses, HypothesisMeetingsScreenErrors, ThrowOnError> => (options.client ?? client).get<HypothesisMeetingsScreenResponses, HypothesisMeetingsScreenErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/meetings/{meetingId}/screen',
    ...options
});

/**
 * «Start møtet» (W1): sets startedAt; the run and the screen in the room open in the client. Only the registrar (403 not_meeting_registrar), only in planlagt (409 meeting_locked), with at least one row in vurderes (409 meeting_agenda_empty). From now until confirmation the submitters of the rows meet the lock (409 in_pending_meeting) when they try to edit — never a word on the outcome (P6). Idempotent: a meeting already started is returned unchanged. AuditEntry hypothesis_meeting.started.
 */
export const hypothesisMeetingsStart = <ThrowOnError extends boolean = false>(options: Options<HypothesisMeetingsStartData, ThrowOnError>): RequestResult<HypothesisMeetingsStartResponses, HypothesisMeetingsStartErrors, ThrowOnError> => (options.client ?? client).post<HypothesisMeetingsStartResponses, HypothesisMeetingsStartErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/meetings/{meetingId}/start',
    ...options
});

/**
 * The questions the caller is to answer as a source's owner (or, for a deactivated owner's source, as the eier), open ones, oldest first — the «Til deg» (for you) rows (W10: «Jonas Berg spør om avspillingsloggen · svar innen 28. okt»). Without the drafts; the draft comes with the single question. Writes no audit row.
 */
export const hypothesisSourceQuestionsListQuestions = <ThrowOnError extends boolean = false>(options?: Options<HypothesisSourceQuestionsListQuestionsData, ThrowOnError>): RequestResult<HypothesisSourceQuestionsListQuestionsResponses, HypothesisSourceQuestionsListQuestionsErrors, ThrowOnError> => (options?.client ?? client).get<HypothesisSourceQuestionsListQuestionsResponses, HypothesisSourceQuestionsListQuestionsErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/source-questions',
    ...options
});

/**
 * One question. For its answerer: with the draft, read-only, while the question is aapen — and without it afterwards (Kh15; «Etterpå ser du ikke utkastet», afterwards you do not see the draft). For its asker: the question, without the draft (she has it). Anyone else, the eier included: 404 source_question_not_found — the eier sees the question on the source (MetricSourceDetail.openQuestions), never the draft. Writes no audit row (Kh9): the access is granted by the question, not logged per reading.
 */
export const hypothesisSourceQuestionsGetQuestion = <ThrowOnError extends boolean = false>(options: Options<HypothesisSourceQuestionsGetQuestionData, ThrowOnError>): RequestResult<HypothesisSourceQuestionsGetQuestionResponses, HypothesisSourceQuestionsGetQuestionErrors, ThrowOnError> => (options.client ?? client).get<HypothesisSourceQuestionsGetQuestionResponses, HypothesisSourceQuestionsGetQuestionErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/source-questions/{questionId}',
    ...options
});

/**
 * The source's owner answers (W10, «Send forslaget»): a suggestion for the metric and/or her assessment of the definition (400 validation_failed with neither). Only the answerer (403 not_source_owner for the asker and the eier when the source's owner is active; 404 source_question_not_found for anyone else), only while aapen (409 source_question_closed).
 *
 * In one transaction: the question becomes besvart and her access to the draft ends (Kh15); a sourceAssessment is written onto the draft's source status at once (Hypothesis.sourceStatus, with her as sourceVerifiedBy when verifisert) — the first of the rules at «Send inn»; the draft's lastActivityAt is updated. The suggestion waits for the submitter's choice. AuditEntry hypothesis.source_question_answered (ids, never text).
 */
export const hypothesisSourceQuestionsAnswer = <ThrowOnError extends boolean = false>(options: Options<HypothesisSourceQuestionsAnswerData, ThrowOnError>): RequestResult<HypothesisSourceQuestionsAnswerResponses, HypothesisSourceQuestionsAnswerErrors, ThrowOnError> => (options.client ?? client).post<HypothesisSourceQuestionsAnswerResponses, HypothesisSourceQuestionsAnswerErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/source-questions/{questionId}/answer',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Closes the question without an answer: the asker («lukker spørsmålet», closes the question), or the answerer («Lukk uten forslag», close without a suggestion). The eier: 403 not_source_owner, unless she answers for a deactivated owner. Anyone else: 404 source_question_not_found. Only while aapen (409 source_question_closed). The access to the draft ends (Kh15). AuditEntry hypothesis.source_question_closed.
 */
export const hypothesisSourceQuestionsCloseQuestion = <ThrowOnError extends boolean = false>(options: Options<HypothesisSourceQuestionsCloseQuestionData, ThrowOnError>): RequestResult<HypothesisSourceQuestionsCloseQuestionResponses, HypothesisSourceQuestionsCloseQuestionErrors, ThrowOnError> => (options.client ?? client).post<HypothesisSourceQuestionsCloseQuestionResponses, HypothesisSourceQuestionsCloseQuestionErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/source-questions/{questionId}/close',
    ...options
});

/**
 * The submitter's choice on an answer with a suggestion (W8): «Bruk forslaget» (use the suggestion — metricName becomes the suggestion, as an autosave) or «Behold mitt» (keep mine). Only the asker (403 not_submitter for the answerer; 404 source_question_not_found for anyone else), only while the draft is in utkast (409 invalid_status_transition), only on a besvart question with a suggestion and no choice yet (409 source_question_closed). Older baseVersion: 409 draft_changed_elsewhere. The response is the draft. No audit row — it is an autosave of the draft, as PATCH in utkast.
 */
export const hypothesisSourceQuestionsDecide = <ThrowOnError extends boolean = false>(options: Options<HypothesisSourceQuestionsDecideData, ThrowOnError>): RequestResult<HypothesisSourceQuestionsDecideResponses, HypothesisSourceQuestionsDecideErrors, ThrowOnError> => (options.client ?? client).post<HypothesisSourceQuestionsDecideResponses, HypothesisSourceQuestionsDecideErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/source-questions/{questionId}/decision',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The catalogue («Kilder hos [leietaker]»), ordered by name. Everyone in the room reads it — the form's picker and the Settings page use the same call. Archived sources only with includeArchived. openQuestionCount and freeTextSuggestion only for the eier. Writes no audit row.
 */
export const hypothesisSourcesList = <ThrowOnError extends boolean = false>(options?: Options<HypothesisSourcesListData, ThrowOnError>): RequestResult<HypothesisSourcesListResponses, HypothesisSourcesListErrors, ThrowOnError> => (options?.client ?? client).get<HypothesisSourcesListResponses, HypothesisSourcesListErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/sources',
    ...options
});

/**
 * «Legg til kilde» (add source): the eier adds a source and sets its owner (W9b). The owner must be an active panel user with at least bidragsyter in the room (404 admin_user_not_found; 422 validation_failed without a role in the room). Name taken among active sources: 409 metric_source_name_taken. measures below the minimum: 422 text_too_short. status = verifisert records the caller as verifiedBy. AuditEntry metric_source.created (ids, never text).
 */
export const hypothesisSourcesCreate = <ThrowOnError extends boolean = false>(options: Options<HypothesisSourcesCreateData, ThrowOnError>): RequestResult<HypothesisSourcesCreateResponses, HypothesisSourcesCreateErrors, ThrowOnError> => (options.client ?? client).post<HypothesisSourcesCreateResponses, HypothesisSourcesCreateErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/sources',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * One source with its numbers. openQuestions — who asks and what, never the draft (Kh15) — only for the eier and the source's owner. Unknown or another tenant's: 404 metric_source_not_found. Writes no audit row.
 */
export const hypothesisSourcesGet = <ThrowOnError extends boolean = false>(options: Options<HypothesisSourcesGetData, ThrowOnError>): RequestResult<HypothesisSourcesGetResponses, HypothesisSourcesGetErrors, ThrowOnError> => (options.client ?? client).get<HypothesisSourcesGetResponses, HypothesisSourcesGetErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/sources/{sourceId}',
    ...options
});

/**
 * «Endre» (edit): the eier, or the source's own owner correcting her source — anyone else 403 not_source_owner. Only the eier changes ownerId (403 insufficient_role for the source's owner). An archived source cannot be changed (409 metric_source_archived). Rules on MetricSourceUpdate; a change never moves hypotheses already submitted. AuditEntry metric_source.updated, and metric_source.verified when the status becomes verifisert.
 */
export const hypothesisSourcesUpdate = <ThrowOnError extends boolean = false>(options: Options<HypothesisSourcesUpdateData, ThrowOnError>): RequestResult<HypothesisSourcesUpdateResponses, HypothesisSourcesUpdateErrors, ThrowOnError> => (options.client ?? client).patch<HypothesisSourcesUpdateResponses, HypothesisSourcesUpdateErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/sources/{sourceId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * «Arkiver kilden …» (archive the source): never deleted. The source is no longer offered in the form, stays on the hypotheses that use it, and its open questions are closed (the access to the drafts ends, Kh15). Idempotent: an archived source answers 200 unchanged. AuditEntry metric_source.archived.
 */
export const hypothesisSourcesArchive = <ThrowOnError extends boolean = false>(options: Options<HypothesisSourcesArchiveData, ThrowOnError>): RequestResult<HypothesisSourcesArchiveResponses, HypothesisSourcesArchiveErrors, ThrowOnError> => (options.client ?? client).post<HypothesisSourcesArchiveResponses, HypothesisSourcesArchiveErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/sources/{sourceId}/archive',
    ...options
});

/**
 * The hypothesis in detail with the whole history. Notes are not included (separate call, hypoteser:leser). Others' drafts: 404. Writes no audit row (Kh9).
 */
export const hypothesesGet = <ThrowOnError extends boolean = false>(options: Options<HypothesesGetData, ThrowOnError>): RequestResult<HypothesesGetResponses, HypothesesGetErrors, ThrowOnError> => (options.client ?? client).get<HypothesesGetResponses, HypothesesGetErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/{id}',
    ...options
});

/**
 * Saves the form: autosave in utkast without gates, «the submitter revises» in mottatt and vurderes (new revision, awaitingSubmitter is reset, the deadline stands). In mottatt and vurderes the same gates run as on «Send inn» (409 hypothesis_incomplete with the field list; 422 text_too_short); if one fails, nothing is saved and no revision is created. Submitter only (403 not_submitter). An older baseVersion gives 409 draft_changed_elsewhere; other statuses 409 wording_locked. From H3.3: metricSourceId with sourceText, sourceClaim or updateFrequency set gives 422 source_from_catalogue (rules on HypothesisForm); supersedesId and differenceNote are writable only in utkast (409 wording_locked after, 422 supersedes_target_invalid). From H3.2: while a decision on it is pending in a decision meeting (Hypothesis.decisionPending — from «Start møtet» until the decider has confirmed, and after a confirmed rejection until its justification is written) 409 in_pending_meeting, which never says the outcome, the meeting or who decides (P6, P10); withdrawing still works. AuditEntry hypothesis.revised for a revision, none for autosave.
 */
export const hypothesesUpdate = <ThrowOnError extends boolean = false>(options: Options<HypothesesUpdateData, ThrowOnError>): RequestResult<HypothesesUpdateResponses, HypothesesUpdateErrors, ThrowOnError> => (options.client ?? client).patch<HypothesesUpdateResponses, HypothesesUpdateErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The proposed owner takes ownership — the prerequisite for start (409 owner_not_accepted otherwise). Only the proposed one (403 not_proposed_owner), in valgt, testes or pa_pause (409 invalid_status_transition otherwise) — «Gi videre» can give a new owner also after start, and the new owner takes ownership the same way. Idempotent — a repeated call gives no new row. Row in the timeline (the status stands, kind = eierskap_tatt). AuditEntry hypothesis.owner_taken.
 */
export const hypothesesAcceptOwnership = <ThrowOnError extends boolean = false>(options: Options<HypothesesAcceptOwnershipData, ThrowOnError>): RequestResult<HypothesesAcceptOwnershipResponses, HypothesesAcceptOwnershipErrors, ThrowOnError> => (options.client ?? client).post<HypothesesAcceptOwnershipResponses, HypothesesAcceptOwnershipErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/{id}/accept-ownership',
    ...options
});

/**
 * Transition 7, valgt → valgt («Juster før start», Adjust before start): the owner or the reviewer (403 not_owner). Only in valgt before start (409 wording_locked). A threshold that is not a number gives 422 threshold_not_numeric. Gives a revision (adjustment) that must be approved before start; the current form does not change before approval. proposedReply is stored on the revision, shown only to the decider and the proposer, and deleted at the decision. Row in the timeline (kind = justering_foreslatt). AuditEntry hypothesis.revised.
 */
export const hypothesesAdjust = <ThrowOnError extends boolean = false>(options: Options<HypothesesAdjustData, ThrowOnError>): RequestResult<HypothesesAdjustResponses, HypothesesAdjustErrors, ThrowOnError> => (options.client ?? client).post<HypothesesAdjustResponses, HypothesesAdjustErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/{id}/adjust',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The decider approves the latest adjustment (403 not_decider; 409 invalid_status_transition without an unapproved adjustment). approvedRevision is set, and the adjustment's form becomes current only now; the reply (kind = justering) is mandatory and is sent now, and a reply identical to the revision's proposedReply is refused (422 template_unmodified), and proposedReply is deleted. Row in the timeline (kind = justering_godkjent). AuditEntry hypothesis.revised.
 */
export const hypothesesApproveAdjustment = <ThrowOnError extends boolean = false>(options: Options<HypothesesApproveAdjustmentData, ThrowOnError>): RequestResult<HypothesesApproveAdjustmentResponses, HypothesesApproveAdjustmentErrors, ThrowOnError> => (options.client ?? client).post<HypothesesApproveAdjustmentResponses, HypothesesApproveAdjustmentErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/{id}/approve-adjustment',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * «Gi videre» (Hand over): new owner and/or new decider. Only the hypothesis's decider (403 not_decider), in valgt, testes and pa_pause (409 invalid_status_transition). The new owner must take ownership anew; ownerAcceptedAt is reset. No reason, no reply. Row in the timeline (the status stands, kind = gitt_videre). AuditEntry hypothesis.owner_taken on a change of owner.
 */
export const hypothesesAssign = <ThrowOnError extends boolean = false>(options: Options<HypothesesAssignData, ThrowOnError>): RequestResult<HypothesesAssignResponses, HypothesesAssignErrors, ThrowOnError> => (options.client ?? client).post<HypothesesAssignResponses, HypothesesAssignErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/{id}/assign',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The owner writes or rewrites the conclusion (403 not_owner). Only in testes (409 invalid_status_transition); frozen gives 409 conclusion_frozen. «Ingen» (None) without a sentence: 422 open_blocking_required / data_limitations_required. The status stays in testes until the decider confirms. No reply to the submitter yet. With programReportId (H3.4): the report must belong to one of the hypothesis's programmes (422 program_report_not_linked; unknown 404 report_not_found); the server stores the reference and fills in nothing.
 */
export const hypothesesConclude = <ThrowOnError extends boolean = false>(options: Options<HypothesesConcludeData, ThrowOnError>): RequestResult<HypothesesConcludeResponses, HypothesesConcludeErrors, ThrowOnError> => (options.client ?? client).put<HypothesesConcludeResponses, HypothesesConcludeErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/{id}/conclusion',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sends the conclusion notice to the end users behind the evidence (H3.1) — written, previewed and sent in one step by the hypothesis's owner; when the hypothesis has NO owner (the proposed owner declined and it was stopped before a new one was set), by the decider who stopped it — the actor of the transition to stoppet. Anyone else: 403 not_owner. Only in konkludert or stoppet (409 invalid_status_transition); once per hypothesis, and not after «Ingen notis» (409 conclusion_notice_already_sent for both); at least one recipient (409 conclusion_notice_no_recipients); the text at least hypothesisMinFieldLength (422 text_too_short). Fetch the hypothesis or its evidence BEFORE, so the panel can show «Sendes til N» (will be sent to N) — N is evidenceReach. Not sending is allowed: there is no deadline and no reminder, and «Ingen notis» (skipConclusionNotice) records that choice.
 *
 * In one transaction: the notice is stored with recipientCount frozen; one receipt per case with a subject behind the evidence (the linked cases, the duplicates merged into them and the «Ja, jeg også» (me too) confirmations of their known issue — the same set evidenceReach counts) — including cases that already have their reply or are closed; the evidence is frozen (evidence_locked from now on); ONE webhook event submission.conclusion_notice with notice id, case ids and pseudonyms, never text (WebhookEventType); AuditEntry hypothesis.conclusion_notice_sent, never text. Nothing on the cases changes — not status, not reply, not lastActivityAt — and no Reply is created (DD-27). The cases show the notice in «Mine innspill» (my submissions) as conclusionNotices. Updates the hypothesis's lastActivityAt.
 */
export const hypothesesSendConclusionNotice = <ThrowOnError extends boolean = false>(options: Options<HypothesesSendConclusionNoticeData, ThrowOnError>): RequestResult<HypothesesSendConclusionNoticeResponses, HypothesesSendConclusionNoticeErrors, ThrowOnError> => (options.client ?? client).post<HypothesesSendConclusionNoticeResponses, HypothesesSendConclusionNoticeErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/{id}/conclusion-notice',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * «Ingen notis» (no notice) (H3.1): the owner records that no conclusion notice will be sent — the same right as sending (the owner; stopped without an owner, the decider who stopped it; anyone else 403 not_owner), the same statuses (konkludert or stoppet, 409 invalid_status_transition), and only while nothing is decided (409 conclusion_notice_already_sent after a sent notice or an earlier «Ingen notis»). Allowed also with no recipients. Final: no notice can be sent afterwards, the evidence is frozen (evidence_locked), conclusionNoticeDue becomes false and the hypothesis leaves «Til deg». Nothing reaches the end users and no webhook event is emitted. No body. AuditEntry hypothesis.conclusion_notice_skipped. The response is the hypothesis with conclusionNoticeSkipped.
 */
export const hypothesesSkipConclusionNotice = <ThrowOnError extends boolean = false>(options: Options<HypothesesSkipConclusionNoticeData, ThrowOnError>): RequestResult<HypothesesSkipConclusionNoticeResponses, HypothesesSkipConclusionNoticeErrors, ThrowOnError> => (options.client ?? client).post<HypothesesSkipConclusionNoticeResponses, HypothesesSkipConclusionNoticeErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/{id}/conclusion-notice/skip',
    ...options
});

/**
 * Transition 11, testes → konkludert: the decider confirms (403 not_decider; 409 conclusion_missing without a conclusion). The conclusion is frozen; the reply is mandatory. AuditEntry hypothesis.status_changed.
 */
export const hypothesesConfirmConclusion = <ThrowOnError extends boolean = false>(options: Options<HypothesesConfirmConclusionData, ThrowOnError>): RequestResult<HypothesesConfirmConclusionResponses, HypothesesConfirmConclusionErrors, ThrowOnError> => (options.client ?? client).post<HypothesesConfirmConclusionResponses, HypothesesConfirmConclusionErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/{id}/conclusion/confirm',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The decider sends the conclusion back to the owner with a note (403 not_decider; 409 conclusion_missing). No transition, no reply to the submitter; the owner writes anew.
 */
export const hypothesesSendBackConclusion = <ThrowOnError extends boolean = false>(options: Options<HypothesesSendBackConclusionData, ThrowOnError>): RequestResult<HypothesesSendBackConclusionResponses, HypothesesSendBackConclusionErrors, ThrowOnError> => (options.client ?? client).post<HypothesesSendBackConclusionResponses, HypothesesSendBackConclusionErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/{id}/conclusion/send-back',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Removes the caller's own data pointer, in any status. Only her own — nobody removes another's. Idempotent; 204 also without one. AuditEntry hypothesis.data_pointer_removed when there was one.
 */
export const hypothesisInterestDeleteDataPointer = <ThrowOnError extends boolean = false>(options: Options<HypothesisInterestDeleteDataPointerData, ThrowOnError>): RequestResult<HypothesisInterestDeleteDataPointerResponses, HypothesisInterestDeleteDataPointerErrors, ThrowOnError> => (options.client ?? client).delete<HypothesisInterestDeleteDataPointerResponses, HypothesisInterestDeleteDataPointerErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/{id}/data-pointers/mine',
    ...options
});

/**
 * «Jeg har data på dette» (I have data on this, W15): adds the caller's data pointer, or replaces it — one per person per hypothesis (201 new, 200 replaced). Always named, visible to everyone in the room with the name. Only before the conclusion: mottatt, vurderes, parkert, valgt, testes, pa_pause (409 invalid_status_transition) — afterwards it is too late for the one who decides and tests. text below the minimum: 422 text_too_short; url not https: 400 validation_failed. Updates lastActivityAt. AuditEntry hypothesis.data_pointer_added (ids, never text).
 */
export const hypothesisInterestPutDataPointer = <ThrowOnError extends boolean = false>(options: Options<HypothesisInterestPutDataPointerData, ThrowOnError>): RequestResult<HypothesisInterestPutDataPointerResponses, HypothesisInterestPutDataPointerErrors, ThrowOnError> => (options.client ?? client).put<HypothesisInterestPutDataPointerResponses, HypothesisInterestPutDataPointerErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/{id}/data-pointers/mine',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The decider declines the latest adjustment (403 not_decider; 409 invalid_status_transition without an unapproved adjustment). declinedBy is set on the revision, the current form stands unchanged, and a declined adjustment does not block start. The reply (kind = justering) is mandatory and says why; a reply identical to the revision's proposedReply is refused (422 template_unmodified), and proposedReply is deleted. Row in the timeline (kind = justering_avslatt). AuditEntry hypothesis.revised.
 */
export const hypothesesDeclineAdjustment = <ThrowOnError extends boolean = false>(options: Options<HypothesesDeclineAdjustmentData, ThrowOnError>): RequestResult<HypothesesDeclineAdjustmentResponses, HypothesesDeclineAdjustmentErrors, ThrowOnError> => (options.client ?? client).post<HypothesesDeclineAdjustmentResponses, HypothesesDeclineAdjustmentErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/{id}/decline-adjustment',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The proposed owner declines. owner is reset; the decider names a new one with assign. Only the proposed one (403 not_proposed_owner), only in valgt before ownership is taken (409 invalid_status_transition). Row in the timeline (valgt → valgt, kind = eierskap_avslatt), hidden from the submitter (see HypothesisTransitionKind).
 */
export const hypothesesDeclineOwnership = <ThrowOnError extends boolean = false>(options: Options<HypothesesDeclineOwnershipData, ThrowOnError>): RequestResult<HypothesesDeclineOwnershipResponses, HypothesesDeclineOwnershipErrors, ThrowOnError> => (options.client ?? client).post<HypothesesDeclineOwnershipResponses, HypothesesDeclineOwnershipErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/{id}/decline-ownership',
    ...options
});

/**
 * The evidence for the hypothesis (H3.1): count, reach and anonymous count for everyone who can read the hypothesis; the cases themselves (items) only for a caller with at least leser in innspill, and with a track restriction (M4.11) only cases in the caller's tracks. A contributor, or a handler in hypoteser without a role in innspill, gets the numbers and items omitted — never a case text (Kh7). Others' drafts: 404 hypothesis_not_found. Writes no audit row (Kh9).
 */
export const hypothesesListEvidence = <ThrowOnError extends boolean = false>(options: Options<HypothesesListEvidenceData, ThrowOnError>): RequestResult<HypothesesListEvidenceResponses, HypothesesListEvidenceErrors, ThrowOnError> => (options.client ?? client).get<HypothesesListEvidenceResponses, HypothesesListEvidenceErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/{id}/evidence',
    ...options
});

/**
 * Links a case to the hypothesis as evidence (H3.1) — the one operation behind both «Legg til som grunnlag» (add as evidence) on the case and «Legg til sak» (add case) on the hypothesis. Two requirements in x-innspel-tilgang, checked in this order: innspill:behandler — the right is to handle the case — and hypoteser:bidragsyter — she must be able to see the hypothesis she links to. Each gives 404 room_not_enabled when the tenant does not have the room, and 403 insufficient_role when the role is missing. Then: the hypothesis exists and is not someone else's draft (404 hypothesis_not_found); the case exists and is in a track the caller handles (404 submission_not_found, M4.11 — never 403). Own draft: 409 invalid_status_transition. A hypothesis merged into another (slaatt_sammen, H3.3, produkteier 2026-10-29): 409 invalid_status_transition — its evidence was moved to the one it is continued in (mergedInto), and new cases are linked there. After the conclusion notice is sent: 409 evidence_locked. Any status of the case, anonymous cases included (they never count in reach).
 *
 * Already linked: 200 with the existing link, nothing written. Otherwise 201. Linking changes NOTHING on the case — status, deadline, reply and lastActivityAt stand — and no webhook is emitted; the submitter learns of it only through inTestEvidence while the hypothesis is selected, being tested or paused. Updates the hypothesis's lastActivityAt. AuditEntry hypothesis.evidence_added (the case's and the hypothesis's id, never text).
 */
export const hypothesesAddEvidence = <ThrowOnError extends boolean = false>(options: Options<HypothesesAddEvidenceData, ThrowOnError>): RequestResult<HypothesesAddEvidenceResponses, HypothesesAddEvidenceErrors, ThrowOnError> => (options.client ?? client).post<HypothesesAddEvidenceResponses, HypothesesAddEvidenceErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/{id}/evidence',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Removes a case from the evidence (H3.1), from the case or from the hypothesis. The same gate and the same checks, in the same order, as addEvidence; a case that is not linked to the hypothesis also gives 404 submission_not_found. After the conclusion notice is sent: 409 evidence_locked. Any handler with access to the case can unlink, not only the one who linked. Changes nothing on the case. Updates the hypothesis's lastActivityAt. AuditEntry hypothesis.evidence_removed.
 */
export const hypothesesRemoveEvidence = <ThrowOnError extends boolean = false>(options: Options<HypothesesRemoveEvidenceData, ThrowOnError>): RequestResult<HypothesesRemoveEvidenceResponses, HypothesesRemoveEvidenceErrors, ThrowOnError> => (options.client ?? client).delete<HypothesesRemoveEvidenceResponses, HypothesesRemoveEvidenceErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/{id}/evidence/{submissionId}',
    ...options
});

/**
 * A finding, by the owner (403 not_owner). maalepunkt and observasjon in valgt, testes and pa_pause; rettelse only in konkludert and stoppet (409 invalid_status_transition). Updates lastActivityAt.
 */
export const hypothesesAddFinding = <ThrowOnError extends boolean = false>(options: Options<HypothesesAddFindingData, ThrowOnError>): RequestResult<HypothesesAddFindingResponses, HypothesesAddFindingErrors, ThrowOnError> => (options.client ?? client).post<HypothesesAddFindingResponses, HypothesesAddFindingErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/{id}/findings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Adds an external link (H3.5, P10, P11). Who: the hypothesis's owner, reviewer or decider — whatever the room role — or behandler in hypoteser, or eier; anyone else 403 insufficient_role (the submitter and other contributors see the links, never add them). Others' drafts: 404 hypothesis_not_found. In utkast and trukket: 409 invalid_status_transition; every other status is allowed, also after the conclusion — the follow-up issue is often made afterwards. A fourth link: 409 external_link_limit_reached. The address: 422 external_link_url_invalid for anything but an absolute https address with a host, or with a user name or password; over 500 characters 400 validation_failed. The label is trimmed, 1–40 (400 validation_failed).
 *
 * The same address already on the hypothesis: 200 with the existing link, nothing written. Otherwise 201. Updates the hypothesis's lastActivityAt. No webhook event. AuditEntry hypothesis.link_added with target <hypothesis>/<link> — never the address or the label.
 */
export const hypothesesAddExternalLink = <ThrowOnError extends boolean = false>(options: Options<HypothesesAddExternalLinkData, ThrowOnError>): RequestResult<HypothesesAddExternalLinkResponses, HypothesesAddExternalLinkErrors, ThrowOnError> => (options.client ?? client).post<HypothesesAddExternalLinkResponses, HypothesesAddExternalLinkErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/{id}/links',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Removes an external link (H3.5). The same right and the same statuses as addExternalLink (403 insufficient_role; 409 invalid_status_transition in utkast and trukket) — anyone with the right can remove any link, not only the one who added it. A link not on the hypothesis: 404 external_link_not_found. Final on the server: the undo is the client's — the panel holds the call back for five seconds and sends nothing if «Angre» (undo) is pressed (DD-70). Updates the hypothesis's lastActivityAt. No webhook event. AuditEntry hypothesis.link_removed with target <hypothesis>/<link>.
 */
export const hypothesesRemoveExternalLink = <ThrowOnError extends boolean = false>(options: Options<HypothesesRemoveExternalLinkData, ThrowOnError>): RequestResult<HypothesesRemoveExternalLinkResponses, HypothesesRemoveExternalLinkErrors, ThrowOnError> => (options.client ?? client).delete<HypothesesRemoveExternalLinkResponses, HypothesesRemoveExternalLinkErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/{id}/links/{linkId}',
    ...options
});

/**
 * «Målingen er klar» (The measurement is ready): the source was maa_bygges, and the measurement now exists. The one building the measurement (measurementOwner), the reviewer or the decider (403 not_owner otherwise). Only in valgt with sourceStatus = maa_bygges (409 invalid_status_transition otherwise). sourceStatus becomes uavklart_definisjon: the source must still be verified, or released by the decider (override uavklart_kilde), before start. Row in the timeline (valgt → valgt, kind = maling_klar) with name and date. AuditEntry hypothesis.measurement_ready.
 */
export const hypothesesMeasurementReady = <ThrowOnError extends boolean = false>(options: Options<HypothesesMeasurementReadyData, ThrowOnError>): RequestResult<HypothesesMeasurementReadyResponses, HypothesesMeasurementReadyErrors, ThrowOnError> => (options.client ?? client).post<HypothesesMeasurementReadyResponses, HypothesesMeasurementReadyErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/{id}/measurement-ready',
    ...options
});

/**
 * The hypothesis's meetings for its own log (W11b): put on the agenda, the outcome, and the numbers stored from each confirmed meeting. leser and up in the room. The numbers only while «Menneskesatte tall» is on. For the hypothesis's submitter and co-submitters, also when they are leser and up: never registeredBy and never the numbers (P4, P6). A contributor — the submitter included — reads the transition row in Hypothesis.transitions instead: the meeting's name and date, never who registered and never the numbers (P6). Writes no audit row (Kh9).
 */
export const hypothesisMeetingLogMeetings = <ThrowOnError extends boolean = false>(options: Options<HypothesisMeetingLogMeetingsData, ThrowOnError>): RequestResult<HypothesisMeetingLogMeetingsResponses, HypothesisMeetingLogMeetingsErrors, ThrowOnError> => (options.client ?? client).get<HypothesisMeetingLogMeetingsResponses, HypothesisMeetingLogMeetingsErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/{id}/meetings',
    ...options
});

/**
 * Transition 13, mottatt or vurderes → slaatt_sammen (W12–W13): the hypothesis in the path is merged into targetId, which leads on. The reviewer — behandler in the room (or eier). Submitter or co-submitter of either: 403 own_hypothesis (H13). Either unknown, another tenant's or someone else's draft: 404 hypothesis_not_found. The one in the path not in mottatt or vurderes: 409 invalid_status_transition. The target not in mottatt or vurderes, the same, or itself merged: 422 merge_target_invalid. «Hent over» (carry over) on a part that is not missing: 422 carry_over_invalid. The reply is mandatory and the same to both (HypothesisMergeRequest).
 *
 * In one transaction: the merged one → slaatt_sammen with mergedInto (an overgang with the reply), its deadline and awaitingSubmitter end; the target gets a row kind = sammenslaaing with mergedFrom and the same reply, and keeps its status and deadline; the merged one's submitter and co-submitters become co-submitters on the target (never twice, never the target's own submitter); carryOver gives ONE revision on the target (kind = sammenslaaing); the merged one's followers (HypothesisWatch) also follow the target; the merged one's evidence (H3.1, HypothesisEvidence) moves to the target as a union — each case once, keeping who linked it and when, and none left on the merged one — so the target's evidenceCount, evidenceReach and conclusion notice count the union. Neither can have a decided conclusion notice (it is decided only in konkludert or stoppet, and there is no way back), so the evidence is never locked here. Data pointers stay where they were given. Updates both lastActivityAt. AuditEntry hypothesis.merged (both ids). No webhook.
 *
 * «Angre» (undo) for 5 s is the client's: it holds the call until the toast's bar has run out — the transition is append-only, and there is NO undo endpoint («Hypotesekontrakten før H1.4», 2026-09-26; DD-10, DD-24). Nobody has received anything until the call is made. The response is the target.
 */
export const hypothesisMemoryMerge = <ThrowOnError extends boolean = false>(options: Options<HypothesisMemoryMergeData, ThrowOnError>): RequestResult<HypothesisMemoryMergeResponses, HypothesisMemoryMergeErrors, ThrowOnError> => (options.client ?? client).post<HypothesisMemoryMergeResponses, HypothesisMemoryMergeErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/{id}/merge',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Open hypotheses that look like this one, for the reviewer (W11 «ligner på H-143», W12): at most three in mottatt or vurderes, not merged, never itself — text likeness on change and audience. Only for a hypothesis in mottatt or vurderes (409 invalid_status_transition). Suggestions only; nothing is merged by itself. Writes no audit row.
 */
export const hypothesisMemoryMergeCandidates = <ThrowOnError extends boolean = false>(options: Options<HypothesisMemoryMergeCandidatesData, ThrowOnError>): RequestResult<HypothesisMemoryMergeCandidatesResponses, HypothesisMemoryMergeCandidatesErrors, ThrowOnError> => (options.client ?? client).get<HypothesisMemoryMergeCandidatesResponses, HypothesisMemoryMergeCandidatesErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/{id}/merge-candidates',
    ...options
});

/**
 * «Slik har andre tallfestet» (how others have quantified, W5): at most three konkludert hypotheses whose metric looks like this one's — text likeness on the stored metricName, or on effect while metricName is empty; with a catalogue source, those from the same source come first. Only the submitter (403 not_submitter), where she can edit the form: utkast, mottatt, vurderes (409 invalid_status_transition). Empty = «Ingen hos [leietaker] har konkludert en lignende ennå». No entity and no model. Writes no audit row.
 */
export const hypothesisMemoryMetricExamples = <ThrowOnError extends boolean = false>(options: Options<HypothesisMemoryMetricExamplesData, ThrowOnError>): RequestResult<HypothesisMemoryMetricExamplesResponses, HypothesisMemoryMetricExamplesErrors, ThrowOnError> => (options.client ?? client).get<HypothesisMemoryMetricExamplesResponses, HypothesisMemoryMetricExamplesErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/{id}/metric-examples',
    ...options
});

/**
 * «Trenger mer» (Needs more) — not a transition. Only in mottatt and vurderes (409 invalid_status_transition), at most three (409 needs_more_limit), own hypothesis 403 own_hypothesis. Sets awaitingSubmitter; the deadline keeps running. The reply (kind = trenger_mer) is mandatory.
 */
export const hypothesesNeedsMore = <ThrowOnError extends boolean = false>(options: Options<HypothesesNeedsMoreData, ThrowOnError>): RequestResult<HypothesesNeedsMoreResponses, HypothesesNeedsMoreErrors, ThrowOnError> => (options.client ?? client).post<HypothesesNeedsMoreResponses, HypothesesNeedsMoreErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/{id}/needs-more',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Internal notes on the hypothesis, oldest first. Behind hypoteser:leser on purpose: a bidragsyter never sees a note (Kh7), not even on a hypothesis she owns — that is decided anew when the need has been measured.
 */
export const hypothesesListNotes = <ThrowOnError extends boolean = false>(options: Options<HypothesesListNotesData, ThrowOnError>): RequestResult<HypothesesListNotesResponses, HypothesesListNotesErrors, ThrowOnError> => (options.client ?? client).get<HypothesesListNotesResponses, HypothesesListNotesErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/{id}/notes',
    ...options
});

/**
 * Internal note (DD-23, DD-66). Never leaves the panel. Updates lastActivityAt.
 */
export const hypothesesAddNote = <ThrowOnError extends boolean = false>(options: Options<HypothesesAddNoteData, ThrowOnError>): RequestResult<HypothesesAddNoteResponses, HypothesesAddNoteErrors, ThrowOnError> => (options.client ?? client).post<HypothesesAddNoteResponses, HypothesesAddNoteErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/{id}/notes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * «Én side» (one page, H23, P8): the content of the printable sheet for a konkludert or stoppet hypothesis, and the record that it was exported. A POST, because it writes: every call writes ONE AuditEntry hypothesis.exported (target the hypothesis) in the same transaction as the read — the panel calls it when the page opens, and if the call fails there is nothing to print and nothing is recorded. A GET never writes the audit log (Kh9); the detail itself has no export.
 *
 * Who: everyone who can read the hypothesis (hypoteser:bidragsyter). Others' drafts: 404 hypothesis_not_found. Other statuses than konkludert and stoppet: 409 invalid_status_transition. No body. Never notes, never scores (HypothesisOnePage). No webhook event, and lastActivityAt stands.
 */
export const hypothesesExportOnePage = <ThrowOnError extends boolean = false>(options: Options<HypothesesExportOnePageData, ThrowOnError>): RequestResult<HypothesesExportOnePageResponses, HypothesesExportOnePageErrors, ThrowOnError> => (options.client ?? client).post<HypothesesExportOnePageResponses, HypothesesExportOnePageErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/{id}/one-page',
    ...options
});

/**
 * The decider releases a lock before start, with a reason: baseline_mangler or uavklart_kilde (403 not_decider; ett_maalepunkt here gives 400). Only in valgt (409 invalid_status_transition). Stored in the timeline (valgt → valgt, kind = overstyring) with name, date and reason. AuditEntry hypothesis.override.
 */
export const hypothesesOverride = <ThrowOnError extends boolean = false>(options: Options<HypothesesOverrideData, ThrowOnError>): RequestResult<HypothesesOverrideResponses, HypothesesOverrideErrors, ThrowOnError> => (options.client ?? client).post<HypothesesOverrideResponses, HypothesesOverrideErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/{id}/override',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Transition 4, vurderes → parkert. The decider or the reviewer (behandler in the room) — otherwise 403 not_decider. Date from tomorrow to 12 months (422 revisit_date_out_of_range), reason mandatory. parkCount increases; ≥ 2 gives advice to reject, never a lock. AuditEntry hypothesis.status_changed.
 */
export const hypothesesPark = <ThrowOnError extends boolean = false>(options: Options<HypothesesParkData, ThrowOnError>): RequestResult<HypothesesParkResponses, HypothesesParkErrors, ThrowOnError> => (options.client ?? client).post<HypothesesParkResponses, HypothesesParkErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/{id}/park',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Transition 9, valgt or testes → pa_pause. The owner or the decider (403 not_owner). Date from tomorrow to 3 months (422 revisit_date_out_of_range), reason mandatory. AuditEntry hypothesis.status_changed.
 */
export const hypothesesPause = <ThrowOnError extends boolean = false>(options: Options<HypothesesPauseData, ThrowOnError>): RequestResult<HypothesesPauseResponses, HypothesesPauseErrors, ThrowOnError> => (options.client ?? client).post<HypothesesPauseResponses, HypothesesPauseErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/{id}/pause',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The hypothesis's programmes and the caller's door (H3.4) — the section «Betaprogram» on the hypothesis, the log lines about programmes, and the frozen reports offered as a starting point on the conclusion (P6). The gate is hypoteser:bidragsyter: everyone who can read the hypothesis. What each item carries depends on the caller's access to innspill (P7): without innspill:leser, the programme's name, product, period, participant count and the reports' texts are omitted — counts and the conclusion stay. door is only for the hypothesis's owner in valgt and testes (P3). Others' drafts: 404 hypothesis_not_found. Writes no audit row (Kh9).
 */
export const hypothesesListPrograms = <ThrowOnError extends boolean = false>(options: Options<HypothesesListProgramsData, ThrowOnError>): RequestResult<HypothesesListProgramsResponses, HypothesesListProgramsErrors, ThrowOnError> => (options.client ?? client).get<HypothesesListProgramsResponses, HypothesesListProgramsErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/{id}/programs',
    ...options
});

/**
 * Makes a beta programme from the hypothesis (H3.4, «Lag betaprogram fra denne …», make a beta programme from this) — the same programme as POST /programs, in utkast, with hypothesisId set and never changed afterwards. Nothing exists before this call: the form is filled in by the client and saved only when the owner presses «Lagre utkast» (save draft) (green criterion).
 *
 * Two requirements in x-innspel-tilgang, checked in this order: innspill:behandler — the right to make a programme — and hypoteser:bidragsyter — she must be able to see the hypothesis. Each gives 404 room_not_enabled when the tenant does not have the room, and 403 insufficient_role when the role is missing. A behandler restricted to tracks (M4.11) is a reader of programmes: 403 insufficient_role. Then, in this order: the hypothesis exists and is not someone else's draft (404 hypothesis_not_found); the caller is the hypothesis's owner (403 not_owner — «eieren lager programmet», the owner makes the programme); the hypothesis is in valgt or testes (409 invalid_status_transition). Then the same rules as POST /programs (400 validation_failed, 404 product_not_found, 422 minors_present_conflict, 422 contacts_exceed_tenant_cap). Several programmes per hypothesis are allowed (P6), for example one per product.
 *
 * The client's prefill rule (the panel, kjerne.md 8.2), from the Hypothesis the owner has open — every field is a proposal she reads and can change, and is marked with where it came from until she changes it:
 * - name ← title (5–80; the field takes 80). Testers see it (P1).
 * - hypothesis ← the FIRST sentence of the form, «Vi tror at {change} for {audience} gir {effect}.» (we believe that … for … gives …), with the same words as the server's sentence (P2). Over 280 characters it is NOT filled in and never shortened: the field stays empty and the whole sentence is shown above it as the source (A6). Testers see it (P1).
 * - successCriterion.text ← metricName; successCriterion.target ← direction, threshold and unit («minst 46 %», at least 46 %).
 * - opensAt ← testStartsOn when set; closesAt ← testEndsOn. The panel turns the dates into times as for dates the owner types.
 * - productId, flagRef, termsUrl, maxContacts and the tasks are never filled in from the hypothesis — the hypothesis has no product; task 1 is the DD-33 default as today.
 * Kh6 (clarified 2026-10-29, P1): the text is the programme's once a human has read and saved it — the acceptance step in the form shows name and hypothesis as the tester will see them before she saves. ProgramView never carries anything from the hypothesis.
 *
 * Updates the hypothesis's lastActivityAt. AuditEntry program.created (target the programme, as for POST /programs); the link to the hypothesis is the programme's stored hypothesisId. No webhook beyond what POST /programs emits, and no row in the hypothesis's timeline (HypothesisTransition) — the log line is built from listPrograms.
 */
export const hypothesesCreateProgram = <ThrowOnError extends boolean = false>(options: Options<HypothesesCreateProgramData, ThrowOnError>): RequestResult<HypothesesCreateProgramResponses, HypothesesCreateProgramErrors, ThrowOnError> => (options.client ?? client).post<HypothesesCreateProgramResponses, HypothesesCreateProgramErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/{id}/programs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Transition 3, mottatt or vurderes → avvist. The decider (from hypothesisDeciders), or the reviewer when hypothesisReviewerMayReject is on — otherwise 403 not_decider. Own hypothesis 403 own_hypothesis. Requires a code and text with a modified template (422 template_unmodified); vurdert_for also requires relatedHypothesisId (422 related_hypothesis_required, H3.3). AuditEntry hypothesis.status_changed.
 */
export const hypothesesReject = <ThrowOnError extends boolean = false>(options: Options<HypothesesRejectData, ThrowOnError>): RequestResult<HypothesesRejectResponses, HypothesesRejectErrors, ThrowOnError> => (options.client ?? client).post<HypothesesRejectResponses, HypothesesRejectErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/{id}/reject',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Transition 10, pa_pause → the previous status (valgt or testes). The owner or the decider (403 not_owner); 409 invalid_status_transition outside pa_pause. AuditEntry hypothesis.status_changed.
 */
export const hypothesesResume = <ThrowOnError extends boolean = false>(options: Options<HypothesesResumeData, ThrowOnError>): RequestResult<HypothesesResumeResponses, HypothesesResumeErrors, ThrowOnError> => (options.client ?? client).post<HypothesesResumeResponses, HypothesesResumeErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/{id}/resume',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Transition 6, vurderes → valgt («Velg», Select). The caller must be in hypothesisDeciders (403 not_decider) and becomes the hypothesis's decider; not the submitter (422 decider_is_submitter); the owner is named and is someone else (422 owner_is_decider, 404 admin_user_not_found, 422 validation_failed without a role in the room). The reply is mandatory. The owner must take ownership themselves. AuditEntry hypothesis.status_changed.
 */
export const hypothesesSelect = <ThrowOnError extends boolean = false>(options: Options<HypothesesSelectData, ThrowOnError>): RequestResult<HypothesesSelectResponses, HypothesesSelectErrors, ThrowOnError> => (options.client ?? client).post<HypothesesSelectResponses, HypothesesSelectErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/{id}/select',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Shortens the decision deadline (in vurderes) or the conclusion deadline (in testes). The decision deadline: behandler in the room (or eier). The conclusion deadline: behandler in the room (or eier), or the hypothesis's decider regardless of room role — a bidragsyter who is not, gets 403 not_decider. The gate is therefore bidragsyter, and the rest is decided on the hypothesis after 404. Never longer (422 deadline_cannot_be_extended), whoever it is; wrong status 409 invalid_status_transition. Visible to the submitter with who and when. AuditEntry hypothesis.deadline_changed.
 */
export const hypothesesShortenDeadline = <ThrowOnError extends boolean = false>(options: Options<HypothesesShortenDeadlineData, ThrowOnError>): RequestResult<HypothesesShortenDeadlineResponses, HypothesesShortenDeadlineErrors, ThrowOnError> => (options.client ?? client).post<HypothesesShortenDeadlineResponses, HypothesesShortenDeadlineErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/{id}/shorten-deadline',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * «Ligner på N som er vurdert før» (looks like N assessed before, H12, W1–W4): at most three earlier hypotheses in avvist, parkert, stoppet or konkludert whose change and audience look like the draft's — text likeness on the STORED draft (pg_trgm, the same kind of search as dedupe in Innspill), never a model, never a score. Never itself, never a draft. Empty until change and audience both have the minimum, and when nothing is similar.
 *
 * Only the submitter (403 not_submitter), only in utkast (409 invalid_status_transition). Never a block: «Send inn» (submit) does not read it. The client waits at most 1 s and shows nothing on time-out or error. The text never goes in the URL — the server reads the saved draft, so the client saves first. Writes no audit row.
 */
export const hypothesisMemorySimilar = <ThrowOnError extends boolean = false>(options: Options<HypothesisMemorySimilarData, ThrowOnError>): RequestResult<HypothesisMemorySimilarResponses, HypothesisMemorySimilarErrors, ThrowOnError> => (options.client ?? client).get<HypothesisMemorySimilarResponses, HypothesisMemorySimilarErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/{id}/similar',
    ...options
});

/**
 * «Spør eieren av kilden» (ask the source's owner, W7) from the submitter's own draft — only the submitter (403 not_submitter), only in utkast (409 invalid_status_transition), with her display name set (409 display_name_missing: the source's owner sees who is asking). The source must exist and not be archived (404 metric_source_not_found, 409 metric_source_archived), and the caller must not own it (422 source_owner_is_asker). One question at a time per draft (409 source_question_open).
 *
 * From now on, and only until the draft is submitted or the question answered or closed, the source's owner reads this ONE draft through GET /hypotheses/source-questions/{questionId} (Kh15) — never through GET /hypotheses/{id}. The question is in her «Til deg» (for you). Nothing is sent outside the panel: no e-mail, no webhook, never the text. Updates the draft's lastActivityAt. AuditEntry hypothesis.source_question_asked (ids, never text).
 */
export const hypothesisSourceQuestionsAsk = <ThrowOnError extends boolean = false>(options: Options<HypothesisSourceQuestionsAskData, ThrowOnError>): RequestResult<HypothesisSourceQuestionsAskResponses, HypothesisSourceQuestionsAskErrors, ThrowOnError> => (options.client ?? client).post<HypothesisSourceQuestionsAskResponses, HypothesisSourceQuestionsAskErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/{id}/source-questions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Transition 8, valgt → testes («Start testen», Start the test), by the owner (403 not_owner). The gates are on HypothesisStartRequest, each with its own 409. The form is locked; the conclusion deadline is set: testEndsOn + hypothesisConclusionDays. AuditEntry hypothesis.status_changed, and hypothesis.override on «Start likevel» (Start anyway).
 */
export const hypothesesStart = <ThrowOnError extends boolean = false>(options: Options<HypothesesStartData, ThrowOnError>): RequestResult<HypothesesStartResponses, HypothesesStartErrors, ThrowOnError> => (options.client ?? client).post<HypothesesStartResponses, HypothesesStartErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/{id}/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Transition 2, mottatt → vurderes: the reviewer (behandler in the room, or eier) saves the quality check and becomes the hypothesis's reviewer. The decision deadline is set: now + hypothesisReviewDays. sourceCheck = ja sets sourceStatus = verifisert. Own hypothesis gives 403 own_hypothesis. AuditEntry hypothesis.status_changed.
 */
export const hypothesesStartReview = <ThrowOnError extends boolean = false>(options: Options<HypothesesStartReviewData, ThrowOnError>): RequestResult<HypothesesStartReviewResponses, HypothesesStartReviewErrors, ThrowOnError> => (options.client ?? client).post<HypothesesStartReviewResponses, HypothesesStartReviewErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/{id}/start-review',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Transition 12, valgt, testes or pa_pause → stoppet, by the decider (403 not_decider). Stop code, the mandatory rows and a reply with a modified template (422 template_unmodified / open_blocking_required / data_limitations_required). Stored as HypothesisConclusion (kind = stopp), frozen. AuditEntry hypothesis.status_changed.
 */
export const hypothesesStop = <ThrowOnError extends boolean = false>(options: Options<HypothesesStopData, ThrowOnError>): RequestResult<HypothesesStopResponses, HypothesesStopErrors, ThrowOnError> => (options.client ?? client).post<HypothesesStopResponses, HypothesesStopErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/{id}/stop',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Transition 1, utkast → mottatt («Send inn», Submit). The gates: every form field at the minimum, threshold with number, direction, unit and date, baseline with date, update frequency (409 hypothesis_incomplete with the field list — a missing threshold is listed as threshold; 422 text_too_short); display name set (409 display_name_missing). Submitter only (403 not_submitter). From H3.3: the source is a catalogue source OR free text with claim and update frequency, and supersedesId and differenceNote require each other (both in the field list); the source status is set by the rules on Hypothesis.sourceStatus, and an open question to a source's owner is closed (her access to the draft ends, Kh15). Gives revision 1 (submission). The receipt is the promise: the number and the date vurderes would give. AuditEntry hypothesis.submitted.
 */
export const hypothesesSubmit = <ThrowOnError extends boolean = false>(options: Options<HypothesesSubmitData, ThrowOnError>): RequestResult<HypothesesSubmitResponses, HypothesesSubmitErrors, ThrowOnError> => (options.client ?? client).post<HypothesesSubmitResponses, HypothesesSubmitErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/{id}/submit',
    ...options
});

/**
 * Transition 5, parkert → vurderes, always by a human — never by itself on revisitAt. New decision deadline from now. 409 invalid_status_transition outside parkert. AuditEntry hypothesis.status_changed.
 */
export const hypothesesUnpark = <ThrowOnError extends boolean = false>(options: Options<HypothesesUnparkData, ThrowOnError>): RequestResult<HypothesesUnparkResponses, HypothesesUnparkErrors, ThrowOnError> => (options.client ?? client).post<HypothesesUnparkResponses, HypothesesUnparkErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/{id}/unpark',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * «Kilden er verifisert» (The source is verified): the reviewer confirms a source that stood as unresolved — after «trenger avklaring» (needs clarification) in the quality check, or after «Målingen er klar». Only the hypothesis's reviewer (403 not_reviewer). Only in valgt with sourceStatus = uavklart_definisjon (409 invalid_status_transition otherwise). sourceStatus becomes verifisert, sourceVerifiedBy and sourceVerifiedAt are set. Row in the timeline (valgt → valgt, kind = kilde_verifisert) with name and date. AuditEntry hypothesis.source_verified. The override uavklart_kilde is the exception, not the path.
 */
export const hypothesesVerifySource = <ThrowOnError extends boolean = false>(options: Options<HypothesesVerifySourceData, ThrowOnError>): RequestResult<HypothesesVerifySourceResponses, HypothesesVerifySourceErrors, ThrowOnError> => (options.client ?? client).post<HypothesesVerifySourceResponses, HypothesesVerifySourceErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/{id}/verify-source',
    ...options
});

/**
 * «Slutt å varsle» (stop notifying): ends the caller's watch, in any status. Idempotent; 204 also when she did not follow it. No audit row.
 */
export const hypothesisInterestUnwatch = <ThrowOnError extends boolean = false>(options: Options<HypothesisInterestUnwatchData, ThrowOnError>): RequestResult<HypothesisInterestUnwatchResponses, HypothesisInterestUnwatchErrors, ThrowOnError> => (options.client ?? client).delete<HypothesisInterestUnwatchResponses, HypothesisInterestUnwatchErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/{id}/watch',
    ...options
});

/**
 * «Varsle meg» (notify me, HypothesisWatch): the caller follows the hypothesis. On EVERY open hypothesis — mottatt, vurderes, parkert, valgt, testes, pa_pause (produkteier 2026-10-29); utkast and final statuses: 409 invalid_status_transition. Idempotent: following twice is one watch. 204.
 *
 * From now on, every status change a human makes puts the hypothesis in the caller's «Til deg» (for you) (HypothesisListQuery.assignedToMe, watchChangedAt) until she clears it — also back from parkert, which never comes back by itself (collision 7). It follows the hypothesis to a final status: that change puts it in «Til deg» one last time, and clearing it ends the watch. The number of followers is never shown anywhere (Kh8). No audit row: a personal notification choice, and a trail of who follows what would be the per-person list Kh8 forbids.
 */
export const hypothesisInterestWatch = <ThrowOnError extends boolean = false>(options: Options<HypothesisInterestWatchData, ThrowOnError>): RequestResult<HypothesisInterestWatchResponses, HypothesisInterestWatchErrors, ThrowOnError> => (options.client ?? client).put<HypothesisInterestWatchResponses, HypothesisInterestWatchErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/{id}/watch',
    ...options
});

/**
 * Clears a followed hypothesis from the caller's «Til deg» (for you) after a status change (watchChangedAt is reset); after a final status it also ends the watch. An explicit press, never set by reading the hypothesis (Kh9) — and therefore no audit row. Idempotent; 204 also without a pending change.
 */
export const hypothesisInterestAcknowledgeWatch = <ThrowOnError extends boolean = false>(options: Options<HypothesisInterestAcknowledgeWatchData, ThrowOnError>): RequestResult<HypothesisInterestAcknowledgeWatchResponses, HypothesisInterestAcknowledgeWatchErrors, ThrowOnError> => (options.client ?? client).post<HypothesisInterestAcknowledgeWatchResponses, HypothesisInterestAcknowledgeWatchErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/{id}/watch/acknowledge',
    ...options
});

/**
 * Transition 14, mottatt, vurderes or parkert → trukket. Submitter only (403 not_submitter); other statuses 409 invalid_status_transition. The hypothesis remains. AuditEntry hypothesis.status_changed.
 */
export const hypothesesWithdraw = <ThrowOnError extends boolean = false>(options: Options<HypothesesWithdrawData, ThrowOnError>): RequestResult<HypothesesWithdrawResponses, HypothesesWithdrawErrors, ThrowOnError> => (options.client ?? client).post<HypothesesWithdrawResponses, HypothesesWithdrawErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/hypotheses/{id}/withdraw',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The register (M2.4): all known issues with counters.
 */
export const knownIssuesList = <ThrowOnError extends boolean = false>(options?: Options<KnownIssuesListData, ThrowOnError>): RequestResult<KnownIssuesListResponses, KnownIssuesListErrors, ThrowOnError> => (options?.client ?? client).get<KnownIssuesListResponses, KnownIssuesListErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/known-issues',
    ...options
});

/**
 * Creates a known issue, from scratch or from a case («Gjør til kjent feil» (Make known issue), f in the inbox). With fromSubmissionId the case goes to kjent_feil and counts in Reach.
 */
export const knownIssuesCreate = <ThrowOnError extends boolean = false>(options: Options<KnownIssuesCreateData, ThrowOnError>): RequestResult<KnownIssuesCreateResponses, KnownIssuesCreateErrors, ThrowOnError> => (options.client ?? client).post<KnownIssuesCreateResponses, KnownIssuesCreateErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/known-issues',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * One known issue with counters — fetch it BEFORE the PATCH to fikset, so the panel can show how many will be notified (M2.4).
 */
export const knownIssuesGet = <ThrowOnError extends boolean = false>(options: Options<KnownIssuesGetData, ThrowOnError>): RequestResult<KnownIssuesGetResponses, KnownIssuesGetErrors, ThrowOnError> => (options.client ?? client).get<KnownIssuesGetResponses, KnownIssuesGetErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/known-issues/{id}',
    ...options
});

/**
 * Updates. status = fikset requires fixedIn (422 fixed_in_required), emits known_issue.fixed once to everyone with Reach (DD-31) and takes the cases with knownIssueId to statusType complete. fikset → aktiv does not exist (409 invalid_status_transition).
 */
export const knownIssuesUpdate = <ThrowOnError extends boolean = false>(options: Options<KnownIssuesUpdateData, ThrowOnError>): RequestResult<KnownIssuesUpdateResponses, KnownIssuesUpdateErrors, ThrowOnError> => (options.client ?? client).patch<KnownIssuesUpdateResponses, KnownIssuesUpdateErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/known-issues/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Who am I — the panel's first call after the session is let in. Proves that the session meets the tenant's two-factor requirement (otherwise 403 mfa_required) and that the user has a seat at a tenant (otherwise 401 — also when the account is deactivated). If the seat was bound by the before-user-created hook but never used, it is activated here (activatedAt is set, AuditEntry admin_user.activated) — the one write this call does, once per seat. Because the call is behind the gate, a seat can never be taken into use by someone who has not completed the two-factor the tenant requires. The token's e-mail claim is never read.
 */
export const meGet = <ThrowOnError extends boolean = false>(options?: Options<MeGetData, ThrowOnError>): RequestResult<MeGetResponses, MeGetErrors, ThrowOnError> => (options?.client ?? client).get<MeGetResponses, MeGetErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/me',
    ...options
});

/**
 * Sets one's own display name («Visningsnavn på adminbrukeren», 2026-09-25). Own only: an owner can never set the name of others, and nobody reads it from the sign-in service. Written through a SECURITY DEFINER function (the API role has no UPDATE on the column). AuditEntry admin_user.display_name_changed — never the name itself.
 */
export const meUpdate = <ThrowOnError extends boolean = false>(options: Options<MeUpdateData, ThrowOnError>): RequestResult<MeUpdateResponses, MeUpdateErrors, ThrowOnError> => (options.client ?? client).patch<MeUpdateResponses, MeUpdateErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/me',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The products with SDK keys (prefix only).
 */
export const productsList = <ThrowOnError extends boolean = false>(options?: Options<ProductsListData, ThrowOnError>): RequestResult<ProductsListResponses, ProductsListErrors, ThrowOnError> => (options?.client ?? client).get<ProductsListResponses, ProductsListErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/products',
    ...options
});

/**
 * Creates a product with one SDK key; the plaintext is in keys[0].key and never exists again (DD-20).
 */
export const productsCreate = <ThrowOnError extends boolean = false>(options: Options<ProductsCreateData, ThrowOnError>): RequestResult<ProductsCreateResponses, ProductsCreateErrors, ThrowOnError> => (options.client ?? client).post<ProductsCreateResponses, ProductsCreateErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/products',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Updates name, platforms, bundle IDs and origins.
 */
export const productsUpdate = <ThrowOnError extends boolean = false>(options: Options<ProductsUpdateData, ThrowOnError>): RequestResult<ProductsUpdateResponses, ProductsUpdateErrors, ThrowOnError> => (options.client ?? client).patch<ProductsUpdateResponses, ProductsUpdateErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/products/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Rotates: creates a new SDK key next to the old one, so both are valid until the old one is revoked (K3). At most two active — if there are already two, the rotation is rejected with 409 invalid_status_transition; revoke one first. The plaintext only here (DD-20).
 */
export const productsRotateKey = <ThrowOnError extends boolean = false>(options: Options<ProductsRotateKeyData, ThrowOnError>): RequestResult<ProductsRotateKeyResponses, ProductsRotateKeyErrors, ThrowOnError> => (options.client ?? client).post<ProductsRotateKeyResponses, ProductsRotateKeyErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/products/{id}/keys',
    ...options
});

/**
 * Revokes an SDK key. Clients with that key get 401 from the next call.
 */
export const productsRevokeKey = <ThrowOnError extends boolean = false>(options: Options<ProductsRevokeKeyData, ThrowOnError>): RequestResult<ProductsRevokeKeyResponses, ProductsRevokeKeyErrors, ThrowOnError> => (options.client ?? client).delete<ProductsRevokeKeyResponses, ProductsRevokeKeyErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/products/{id}/keys/{keyId}',
    ...options
});

/**
 * All programmes.
 */
export const programsList = <ThrowOnError extends boolean = false>(options?: Options<ProgramsListData, ThrowOnError>): RequestResult<ProgramsListResponses, ProgramsListErrors, ThrowOnError> => (options?.client ?? client).get<ProgramsListResponses, ProgramsListErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/programs',
    ...options
});

/**
 * Creates a programme in utkast (4a). With minorsPresent, commitmentFree is forced and termsUrl is rejected (422 minors_present_conflict); maxContacts above the tenant's cap gives 422 contacts_exceed_tenant_cap.
 */
export const programsCreate = <ThrowOnError extends boolean = false>(options: Options<ProgramsCreateData, ThrowOnError>): RequestResult<ProgramsCreateResponses, ProgramsCreateErrors, ThrowOnError> => (options.client ?? client).post<ProgramsCreateResponses, ProgramsCreateErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/programs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The programme page (4c) with counters.
 */
export const programsGet = <ThrowOnError extends boolean = false>(options: Options<ProgramsGetData, ThrowOnError>): RequestResult<ProgramsGetResponses, ProgramsGetErrors, ThrowOnError> => (options.client ?? client).get<ProgramsGetResponses, ProgramsGetErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/programs/{id}',
    ...options
});

/**
 * Updates and moves status. aapen requires hypothesis, success criterion and ≥ 1 task with estimatedMinutes — 409 program_incomplete with what is missing (explained lock, DD-17). avbrutt requires cancelReason and emits program.closed. aktiv cannot be set from here. Tasks cannot be changed after aapen.
 */
export const programsUpdate = <ThrowOnError extends boolean = false>(options: Options<ProgramsUpdateData, ThrowOnError>): RequestResult<ProgramsUpdateResponses, ProgramsUpdateErrors, ThrowOnError> => (options.client ?? client).patch<ProgramsUpdateResponses, ProgramsUpdateErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/programs/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sent invitations without the token — sent, accepted, declined, expired.
 */
export const programsListInvitations = <ThrowOnError extends boolean = false>(options: Options<ProgramsListInvitationsData, ThrowOnError>): RequestResult<ProgramsListInvitationsResponses, ProgramsListInvitationsErrors, ThrowOnError> => (options.client ?? client).get<ProgramsListInvitationsResponses, ProgramsListInvitationsErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/programs/{id}/invitations',
    ...options
});

/**
 * Invites pseudonyms (4b). Requires aapen (409 invalid_status_transition). The token exists in this response and in the webhook program.invitation_created (one per invitation) — never in any GET response. The tenant resolves subject → user and sends the token through its own channel; the platform never sends (DD-12). A subject with an active invitation rotates: new token, the old one stops working.
 */
export const programsInvite = <ThrowOnError extends boolean = false>(options: Options<ProgramsInviteData, ThrowOnError>): RequestResult<ProgramsInviteResponses, ProgramsInviteErrors, ThrowOnError> => (options.client ?? client).post<ProgramsInviteResponses, ProgramsInviteErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/programs/{id}/invitations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The participants with flag status (DD-36): «invitert, ikke slått på» (invited, not turned on) and «trukket, flagg ikke bekreftet av» (withdrawn, flag not confirmed off) are separate states. No sorting on activity, no score (DD-38).
 */
export const programsListParticipants = <ThrowOnError extends boolean = false>(options: Options<ProgramsListParticipantsData, ThrowOnError>): RequestResult<ProgramsListParticipantsResponses, ProgramsListParticipantsErrors, ThrowOnError> => (options.client ?? client).get<ProgramsListParticipantsResponses, ProgramsListParticipantsErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/programs/{id}/participants',
    ...options
});

/**
 * The frozen report. 404 report_not_found before the programme is avsluttet.
 */
export const programsGetReport = <ThrowOnError extends boolean = false>(options: Options<ProgramsGetReportData, ThrowOnError>): RequestResult<ProgramsGetReportResponses, ProgramsGetReportErrors, ThrowOnError> => (options.client ?? client).get<ProgramsGetReportResponses, ProgramsGetReportErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/programs/{id}/report',
    ...options
});

/**
 * Closes the programme and freezes the report (4d, DD-35). Requires avsluttes or aktiv (409 invalid_status_transition); already frozen gives 409 report_frozen. Below 30 answers: dataLimitations cannot be empty (422 data_limitations_required) and payload has no percentages. Emits program.closed. The same numbers go to the tester's thank-you.
 */
export const programsClose = <ThrowOnError extends boolean = false>(options: Options<ProgramsCloseData, ThrowOnError>): RequestResult<ProgramsCloseResponses, ProgramsCloseErrors, ThrowOnError> => (options.client ?? client).post<ProgramsCloseResponses, ProgramsCloseErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/programs/{id}/report',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Is two-factor required here, and how long does the session live — the panel's very first
 * call after the first factor. **This is the only endpoint on the admin surface that answers
 * an `aal1` session, and it is deliberately narrow.**
 *
 * Two-factor can be off per tenant (`TenantSettings.adminMfaRequired`), and the panel cannot
 * know which screen to show after the first factor until it has asked — but it cannot ask
 * behind a gate that presupposes the answer. This call is that hatch, and it is closed around
 * two fields: the requirement and the expiry. Every OTHER admin endpoint, `GET
 * /v1/admin/me` included, gives 403 `mfa_required` to an `aal1` session when the tenant's
 * requirement is on.
 *
 * **The call reads and writes nothing else.** It does not activate a pending seat —
 * activation belongs to `GET /v1/admin/me` and therefore never happens without a session that
 * meets the tenant's requirement. It logs no AuditEntry: it does not open a screenshot and
 * changes nothing (K7). The token's e-mail claim is never read.
 *
 * **Fails closed:** if the tenant's setting cannot be read, the call answers 200 with
 * `adminMfaRequired` = `true`. A requirement that disappears when something goes wrong is not a requirement.
 *
 * 401 is the only refusal, and its meaning is unchanged: unknown or expired token, missing
 * seat, deactivated account, session over eight hours. 403 cannot occur here —
 * a response whose job is to TELL whether two-factor is required cannot be conditional on it
 * having been completed.
 */
export const sessionGet = <ThrowOnError extends boolean = false>(options?: Options<SessionGetData, ThrowOnError>): RequestResult<SessionGetResponses, SessionGetErrors, ThrowOnError> => (options?.client ?? client).get<SessionGetResponses, SessionGetErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/session',
    ...options
});

/**
 * The tenant's settings (5d) including the community checklist with red/green per requirement (DD-18). No secrets (DD-20).
 */
export const settingsGet = <ThrowOnError extends boolean = false>(options?: Options<SettingsGetData, ThrowOnError>): RequestResult<SettingsGetResponses, SettingsGetErrors, ThrowOnError> => (options?.client ?? client).get<SettingsGetResponses, SettingsGetErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/settings',
    ...options
});

/**
 * Updates settings. minorsPresent = true tightens everything in the same
 * request; a value that conflicts with minorsPresent gives 422 minors_present_conflict with
 * the field in the message (K18). Deadline and contacts can be lowered, never raised above 90 / 3.
 *
 * `adminMfaRequired` = false turns off the two-factor requirement for the tenant's panel users and gives
 * AuditEntry `settings.mfa_disabled` in addition to `settings.changed`; the other way gives
 * `settings.mfa_enabled` (K7). The call requires `aal2` as long as the requirement is ON — turning it off
 * can therefore never be done from a session that has not itself completed two-factor. The change
 * applies from the next admin call and signs nobody out. The eight-hour rule is unaffected (K8).
 *
 * The Hypoteser room (H1.2): `hypothesisDeciders` requires that the room is turned on (422
 * `room_not_enabled`) and that each id is an active panel user with at least bidragsyter there, or
 * eier (422 `validation_failed`). The deadlines can be lowered, never raised above 90. No setting
 * turns the room on — only the platform does, in `Tenant.rooms`.
 */
export const settingsUpdate = <ThrowOnError extends boolean = false>(options: Options<SettingsUpdateData, ThrowOnError>): RequestResult<SettingsUpdateResponses, SettingsUpdateErrors, ThrowOnError> => (options.client ?? client).patch<SettingsUpdateResponses, SettingsUpdateErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/settings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The tenant's own numbers for the last weeks (M4.2, maaling.md): status flow in/out per week, the funnel in the widget, submissions and anonymous ones per week, SDK version spread, the loop out, cases per admin session and recurring submitters. Counts, never percentages — the panel computes, and never below 30 (DD-16). Computed on lookup.
 */
export const statsGet = <ThrowOnError extends boolean = false>(options?: Options<StatsGetData, ThrowOnError>): RequestResult<StatsGetResponses, StatsGetErrors, ThrowOnError> => (options?.client ?? client).get<StatsGetResponses, StatsGetErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/stats',
    ...options
});

/**
 * The inbox and Cases (DD-01, DD-11). Without a filter: everything. statusType = reviewing is the inbox; overdue and inactive give «Avgjør nå» (Decide now) and the DD-25 warnings. Sorting with sort = frist (default): overdue first, then inactive, then oldest first. sort = nyest: descending created time, without rank (DD-74).
 */
export const submissionsList = <ThrowOnError extends boolean = false>(options?: Options<SubmissionsListData, ThrowOnError>): RequestResult<SubmissionsListResponses, SubmissionsListErrors, ThrowOnError> => (options?.client ?? client).get<SubmissionsListResponses, SubmissionsListErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/submissions',
    ...options
});

/**
 * The count that IS the front page: «40 til vurdering · 3 uten aktivitet · 3 over frist» (40 under review · 3 without activity · 3 overdue) (DD-01, DD-52).
 */
export const submissionsCounts = <ThrowOnError extends boolean = false>(options?: Options<SubmissionsCountsData, ThrowOnError>): RequestResult<SubmissionsCountsResponses, SubmissionsCountsErrors, ThrowOnError> => (options?.client ?? client).get<SubmissionsCountsResponses, SubmissionsCountsErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/submissions/counts',
    ...options
});

/**
 * The case in detail, with notes, reply, dedupe suggestions (at most three, null if the service did not answer) and attachment metadata. Opening the detail is logged (AuditEntry: who saw which submission).
 */
export const submissionsGet = <ThrowOnError extends boolean = false>(options: Options<SubmissionsGetData, ThrowOnError>): RequestResult<SubmissionsGetResponses, SubmissionsGetErrors, ThrowOnError> => (options.client ?? client).get<SubmissionsGetResponses, SubmissionsGetErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/submissions/{id}',
    ...options
});

/**
 * Triage in one request — status, merge, known issue, deadline, reply. The rules are on SubmissionUpdate. Emits submission.status_changed (ONE, for the last step, also when status jumps several steps forward on the main line — F30) and/or submission.replied via webhook; a merge emits NOTHING (DD-24). The response is the case after the change.
 */
export const submissionsUpdate = <ThrowOnError extends boolean = false>(options: Options<SubmissionsUpdateData, ThrowOnError>): RequestResult<SubmissionsUpdateResponses, SubmissionsUpdateErrors, ThrowOnError> => (options.client ?? client).patch<SubmissionsUpdateResponses, SubmissionsUpdateErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/submissions/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Removes the case's attachment — e.g. a picture of other people. The object is deleted from storage, the case stands unchanged, and the removal is logged (AuditEntry attachment.removed: who and when, never why). Cannot be undone. After removal SubmissionDetail has attachmentRemovedAt and SubmissionStatusView has attachmentRemoved: the submitter sees in «mine innspill» that the picture has been removed, without a reason. No webhook. 404 attachment_not_found when the case has no fully processed attachment, or it has already been removed — the same rule as attachment-url, and what is not fully processed the handler cannot have seen either. A reader gets 403.
 */
export const submissionsRemoveAttachment = <ThrowOnError extends boolean = false>(options: Options<SubmissionsRemoveAttachmentData, ThrowOnError>): RequestResult<SubmissionsRemoveAttachmentResponses, SubmissionsRemoveAttachmentErrors, ThrowOnError> => (options.client ?? client).delete<SubmissionsRemoveAttachmentResponses, SubmissionsRemoveAttachmentErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/submissions/{id}/attachment',
    ...options
});

/**
 * Short-lived URL to the case's screenshot. Logged as «åpnet skjermbilde» (opened screenshot) (report 5). 404 attachment_not_found when the case has no attachment, it is not fully processed, or it has been removed.
 */
export const submissionsAttachmentUrl = <ThrowOnError extends boolean = false>(options: Options<SubmissionsAttachmentUrlData, ThrowOnError>): RequestResult<SubmissionsAttachmentUrlResponses, SubmissionsAttachmentUrlErrors, ThrowOnError> => (options.client ?? client).get<SubmissionsAttachmentUrlResponses, SubmissionsAttachmentUrlErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/submissions/{id}/attachment-url',
    ...options
});

/**
 * Internal note — the default field the handler writes in (DD-23). Never leaves the panel. Updates lastActivityAt.
 */
export const submissionsAddNote = <ThrowOnError extends boolean = false>(options: Options<SubmissionsAddNoteData, ThrowOnError>): RequestResult<SubmissionsAddNoteResponses, SubmissionsAddNoteErrors, ThrowOnError> => (options.client ?? client).post<SubmissionsAddNoteResponses, SubmissionsAddNoteErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/submissions/{id}/notes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The tenant's panel users: active, pending (activatedAt empty) and deactivated.
 */
export const adminUsersList = <ThrowOnError extends boolean = false>(options?: Options<AdminUsersListData, ThrowOnError>): RequestResult<AdminUsersListResponses, AdminUsersListErrors, ThrowOnError> => (options?.client ?? client).get<AdminUsersListResponses, AdminUsersListErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/users',
    ...options
});

/**
 * Gives a seat: creates the panel user with address, role and room roles in one transaction, pending until first sign-in. The address is normalised (lower case, trimmed) and must be free among non-deactivated seats across tenants — one user, one tenant — otherwise 409 admin_user_email_taken without saying where. If anything fails, nothing of the seat exists. AuditEntry admin_user.created, and admin_user.room_role_changed per room in roomAccess.
 */
export const adminUsersCreate = <ThrowOnError extends boolean = false>(options: Options<AdminUsersCreateData, ThrowOnError>): RequestResult<AdminUsersCreateResponses, AdminUsersCreateErrors, ThrowOnError> => (options.client ?? client).post<AdminUsersCreateResponses, AdminUsersCreateErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Changes the access: the role and, for a member, the room roles, in one transaction — «Lagre tilgangen» (Save access) is one call. Applies from the user's next call — the roles are read from the database, never from the token. Idempotent: the same access again gives 200 without an audit row. Own account gives 409 cannot_change_own_role. If anything fails, nothing is changed. AuditEntry admin_user.role_changed when the role changes, and admin_user.room_role_changed per room that changes.
 */
export const adminUsersUpdate = <ThrowOnError extends boolean = false>(options: Options<AdminUsersUpdateData, ThrowOnError>): RequestResult<AdminUsersUpdateResponses, AdminUsersUpdateErrors, ThrowOnError> => (options.client ?? client).patch<AdminUsersUpdateResponses, AdminUsersUpdateErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/users/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Deactivates the account. The user's next admin call gives 401 unauthenticated however fresh the Supabase token is — the session does not survive. The row stays, and everything she did is still traceable. Idempotent: an already deactivated account gives 204. Own account gives 409 cannot_disable_self — that is the rule that guarantees at least one active owner. AuditEntry admin_user.disabled.
 */
export const adminUsersDisable = <ThrowOnError extends boolean = false>(options: Options<AdminUsersDisableData, ThrowOnError>): RequestResult<AdminUsersDisableResponses, AdminUsersDisableErrors, ThrowOnError> => (options.client ?? client).post<AdminUsersDisableResponses, AdminUsersDisableErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/users/{id}/disable',
    ...options
});

/**
 * Reactivates a deactivated account. Idempotent: an active account gives 204. AuditEntry admin_user.enabled.
 */
export const adminUsersEnable = <ThrowOnError extends boolean = false>(options: Options<AdminUsersEnableData, ThrowOnError>): RequestResult<AdminUsersEnableResponses, AdminUsersEnableErrors, ThrowOnError> => (options.client ?? client).post<AdminUsersEnableResponses, AdminUsersEnableErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/users/{id}/enable',
    ...options
});

/**
 * Removes a member's access to one room. Idempotent: a room the user has no role in gives 204 without an audit row. If the last room is removed, the user sees nothing in the panel until an owner gives them a room. 404 admin_user_not_found for a user that does not exist at the tenant; own account gives 409 cannot_change_own_role; an owner gives 409 owner_has_all_rooms. AuditEntry admin_user.room_role_changed.
 */
export const adminUsersRemoveRoomRole = <ThrowOnError extends boolean = false>(options: Options<AdminUsersRemoveRoomRoleData, ThrowOnError>): RequestResult<AdminUsersRemoveRoomRoleResponses, AdminUsersRemoveRoomRoleErrors, ThrowOnError> => (options.client ?? client).delete<AdminUsersRemoveRoomRoleResponses, AdminUsersRemoveRoomRoleErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/users/{id}/rooms/{room}',
    ...options
});

/**
 * Gives or changes a member's role in one room. Idempotent: the same role again gives 200 without a new audit row. Applies from the user's next call — the roles are read from the database, never from the token. 404 admin_user_not_found for a user that does not exist at the tenant; own account gives 409 cannot_change_own_role; an owner gives 409 owner_has_all_rooms; a room the tenant has not turned on gives 422 room_not_enabled; bidragsyter in a room other than hypoteser gives 422 validation_failed. AuditEntry admin_user.room_role_changed.
 */
export const adminUsersSetRoomRole = <ThrowOnError extends boolean = false>(options: Options<AdminUsersSetRoomRoleData, ThrowOnError>): RequestResult<AdminUsersSetRoomRoleResponses, AdminUsersSetRoomRoleErrors, ThrowOnError> => (options.client ?? client).put<AdminUsersSetRoomRoleResponses, AdminUsersSetRoomRoleErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/users/{id}/rooms/{room}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Registered webhooks.
 */
export const webhooksList = <ThrowOnError extends boolean = false>(options?: Options<WebhooksListData, ThrowOnError>): RequestResult<WebhooksListResponses, WebhooksListErrors, ThrowOnError> => (options?.client ?? client).get<WebhooksListResponses, WebhooksListErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/webhooks',
    ...options
});

/**
 * Registers a receiver. Created inactive and unverified; secret exists only here (DD-20). https required, private networks rejected (400 validation_failed). A hypothesis.* event without hypoteser in Tenant.rooms: 422 room_not_enabled (H3.5).
 */
export const webhooksCreate = <ThrowOnError extends boolean = false>(options: Options<WebhooksCreateData, ThrowOnError>): RequestResult<WebhooksCreateResponses, WebhooksCreateErrors, ThrowOnError> => (options.client ?? client).post<WebhooksCreateResponses, WebhooksCreateErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/webhooks',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Deletes the webhook and its delivery log.
 */
export const webhooksRemove = <ThrowOnError extends boolean = false>(options: Options<WebhooksRemoveData, ThrowOnError>): RequestResult<WebhooksRemoveResponses, WebhooksRemoveErrors, ThrowOnError> => (options.client ?? client).delete<WebhooksRemoveResponses, WebhooksRemoveErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/webhooks/{id}',
    ...options
});

/**
 * One webhook.
 */
export const webhooksGet = <ThrowOnError extends boolean = false>(options: Options<WebhooksGetData, ThrowOnError>): RequestResult<WebhooksGetResponses, WebhooksGetErrors, ThrowOnError> => (options.client ?? client).get<WebhooksGetResponses, WebhooksGetErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/webhooks/{id}',
    ...options
});

/**
 * Updates. A new url resets the verification; active = true requires verified (409 webhook_not_verified). events alone is «Endre hendelser» (change events, H3.5): the list is replaced, nothing else changes. A hypothesis.* event without hypoteser in Tenant.rooms: 422 room_not_enabled.
 */
export const webhooksUpdate = <ThrowOnError extends boolean = false>(options: Options<WebhooksUpdateData, ThrowOnError>): RequestResult<WebhooksUpdateResponses, WebhooksUpdateErrors, ThrowOnError> => (options.client ?? client).patch<WebhooksUpdateResponses, WebhooksUpdateErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/webhooks/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The delivery log. status = dead is the dead-letter list that must be visible in the panel (locked).
 */
export const webhooksListDeliveries = <ThrowOnError extends boolean = false>(options: Options<WebhooksListDeliveriesData, ThrowOnError>): RequestResult<WebhooksListDeliveriesResponses, WebhooksListDeliveriesErrors, ThrowOnError> => (options.client ?? client).get<WebhooksListDeliveriesResponses, WebhooksListDeliveriesErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/webhooks/{id}/deliveries',
    ...options
});

/**
 * Retries a dead-letter delivery, once, with the same event_id (idempotent at the receiver). Requires status dead (409 invalid_status_transition).
 */
export const webhooksRetryDelivery = <ThrowOnError extends boolean = false>(options: Options<WebhooksRetryDeliveryData, ThrowOnError>): RequestResult<WebhooksRetryDeliveryResponses, WebhooksRetryDeliveryErrors, ThrowOnError> => (options.client ?? client).post<WebhooksRetryDeliveryResponses, WebhooksRetryDeliveryErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/webhooks/{id}/deliveries/{deliveryId}/retry',
    ...options
});

/**
 * Rotates the secret. The new one exists only in this response; the old one is invalid immediately.
 */
export const webhooksRotateSecret = <ThrowOnError extends boolean = false>(options: Options<WebhooksRotateSecretData, ThrowOnError>): RequestResult<WebhooksRotateSecretResponses, WebhooksRotateSecretErrors, ThrowOnError> => (options.client ?? client).post<WebhooksRotateSecretResponses, WebhooksRotateSecretErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/webhooks/{id}/rotate-secret',
    ...options
});

/**
 * The test button (5d): sends a signed webhook.test event synchronously, one attempt, no retry. Requires verified (409 webhook_not_verified).
 */
export const webhooksTest = <ThrowOnError extends boolean = false>(options: Options<WebhooksTestData, ThrowOnError>): RequestResult<WebhooksTestResponses, WebhooksTestErrors, ThrowOnError> => (options.client ?? client).post<WebhooksTestResponses, WebhooksTestErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/webhooks/{id}/test',
    ...options
});

/**
 * Verifies the URL: sends a signed webhook.verify event with a one-time challenge and requires the receiver to answer 2xx with the challenge value in the body. ok = true sets verifiedAt.
 */
export const webhooksVerify = <ThrowOnError extends boolean = false>(options: Options<WebhooksVerifyData, ThrowOnError>): RequestResult<WebhooksVerifyResponses, WebhooksVerifyErrors, ThrowOnError> => (options.client ?? client).post<WebhooksVerifyResponses, WebhooksVerifyErrors, ThrowOnError>({
    security: [{
            key: 'AdminAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/admin/webhooks/{id}/verify',
    ...options
});

/**
 * Called by Supabase Auth before a NEW user is inserted — one-time code, magic link and Google. Answers with an empty object when `user.email` (normalised) has a pending seat (not deactivated, never activated), and in the same step binds the seat to `user.id` — the sub Supabase is about to create. A bound seat that was never activated can be bound again; an activated one is locked. **Domain seat (H2.7, 2026-10-29):** when no seat exists and the address's domain is in exactly one tenant's `seatDomains`, the platform creates the seat in the same call — `medlem` with `bidragsyter` in `hypoteser`, pending, bound to `user.id` — and answers the same empty object; the audit entry is `admin_user.created` with the new user itself as actor and `admin_user.seat_domain` as target, since no panel user acted. An address that already has a seat at any tenant, active or deactivated, never gets a domain seat. Otherwise 403 with the same neutral error object regardless of reason. Activation happens in GET /v1/admin/me. Existing users never pass through the hook. A rejection gives no audit entry — it is not an action by any panel user.
 */
export const beforeUserCreatedCheck = <ThrowOnError extends boolean = false>(options: Options<BeforeUserCreatedCheckData, ThrowOnError>): RequestResult<BeforeUserCreatedCheckResponses, BeforeUserCreatedCheckErrors, ThrowOnError> => (options.client ?? client).post<BeforeUserCreatedCheckResponses, BeforeUserCreatedCheckErrors, ThrowOnError>({
    security: [{ name: 'webhook-signature', type: 'apiKey' }],
    url: '/v1/hooks/supabase/before-user-created',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Presigned PUT against R2 (EU) for one screenshot, masked on the client before this call (K4). The numbers are checked here (413 attachment_too_large, 415 attachment_type_not_allowed) and again server-side before decoding (K9). 403 screenshots_disabled when the tenant has screenshots off or minorsPresent. The submission must belong to the caller — the same subject, or anonymously: an anonymous submission with a known submissionId (UUIDv7, given only to the creator) — and have been created at most 15 minutes ago (DD-42: the attachment follows right after the text, and a screenshot is never queued). Otherwise 404 submission_not_found. One attachment per submission (409 attachment_already_uploaded).
 */
export const attachmentsPresign = <ThrowOnError extends boolean = false>(options: Options<AttachmentsPresignData, ThrowOnError>): RequestResult<AttachmentsPresignResponses, AttachmentsPresignErrors, ThrowOnError> => (options.client ?? client).post<AttachmentsPresignResponses, AttachmentsPresignErrors, ThrowOnError>({
    security: [{ name: 'X-Innspel-Tenant-Key', type: 'apiKey' }, {
            key: 'FeedbackTokenAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/ingest/attachments/presign',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The client reports that the PUT is done. Starts verification and re-encoding in an isolated process; responds immediately. If verification fails afterwards, the object is deleted and the submission stands without an attachment — the receipt in the client has already said «your text is stored» (DD-42). Addition beyond the brief's list: without a signal the platform would have to poll R2.
 */
export const attachmentsComplete = <ThrowOnError extends boolean = false>(options: Options<AttachmentsCompleteData, ThrowOnError>): RequestResult<AttachmentsCompleteResponses, AttachmentsCompleteErrors, ThrowOnError> => (options.client ?? client).post<AttachmentsCompleteResponses, AttachmentsCompleteErrors, ThrowOnError>({
    security: [{ name: 'X-Innspel-Tenant-Key', type: 'apiKey' }, {
            key: 'FeedbackTokenAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/ingest/attachments/{id}/complete',
    ...options
});

/**
 * The tenant's client configuration for the product the key belongs to (M2.5): character limit, minimum number of characters, screenshot step and privacy link — what the SDK would otherwise have to get duplicated in init(). Works anonymously. The client fetches it every time the widget is opened, never in the background, and falls back to the strictest values (140 · 10 · off) when the call does not answer. Addition beyond M0.1: technical debt from M1.2, owned by M2.5.
 */
export const configGet = <ThrowOnError extends boolean = false>(options?: Options<ConfigGetData, ThrowOnError>): RequestResult<ConfigGetResponses, ConfigGetErrors, ThrowOnError> => (options?.client ?? client).get<ConfigGetResponses, ConfigGetErrors, ThrowOnError>({
    security: [{ name: 'X-Innspel-Tenant-Key', type: 'apiKey' }, {
            key: 'FeedbackTokenAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/ingest/config',
    ...options
});

/**
 * The measurement model's events from the SDK (M4.2, maaling.md) — the platform's own receiver, never a third party (K19). ALWAYS anonymous: a feedback token is ignored, and subject is never stored. The body is closed — no text, no device ID, no IP (IP is held in memory only, for rate limiting, K15). Responds 202 and stores best-effort; the client sends batches and never retries, because the events are counts, not content. Rate-limited per key and IP.
 */
export const eventsSend = <ThrowOnError extends boolean = false>(options: Options<EventsSendData, ThrowOnError>): RequestResult<EventsSendResponses, EventsSendErrors, ThrowOnError> => (options.client ?? client).post<EventsSendResponses, EventsSendErrors, ThrowOnError>({
    security: [{ name: 'X-Innspel-Tenant-Key', type: 'apiKey' }, {
            key: 'FeedbackTokenAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/ingest/events',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Answers a follow-up that has a question («Hvordan gikk det?» (How did it go?) or a checkpoint): three closed choices and an optional sentence. One Response per FollowUp (409 follow_up_already_answered). Only kind = hvordan_gikk_det and sjekkpunkt take answers — a reminder or an offer to leave gives 409 follow_up_not_answerable. The follow-up must have been emitted to the caller's subject (404 follow_up_not_found). The participation goes to fullfoert when all tasks are done and no follow-up is scheduled or unanswered. The response rate in the report is measured against the emitted follow-ups that take answers.
 */
export const programsRespond = <ThrowOnError extends boolean = false>(options: Options<ProgramsRespondData, ThrowOnError>): RequestResult<ProgramsRespondResponses, ProgramsRespondErrors, ThrowOnError> => (options.client ?? client).post<ProgramsRespondResponses, ProgramsRespondErrors, ThrowOnError>({
    security: [{ name: 'X-Innspel-Tenant-Key', type: 'apiKey' }, {
            key: 'FeedbackTokenAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/ingest/follow-ups/{id}/respond',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * RESERVED v2. The TV client creates a handoff session: context in, id + URL + QR as SVG out. Lives 10 min, used once. Works anonymously — identity is decided on the phone. The context is deleted when the session expires without a submission.
 */
export const handoffsCreate = <ThrowOnError extends boolean = false>(options: Options<HandoffsCreateData, ThrowOnError>): RequestResult<HandoffsCreateResponses, HandoffsCreateErrors, ThrowOnError> => (options.client ?? client).post<HandoffsCreateResponses, HandoffsCreateErrors, ThrowOnError>({
    security: [{ name: 'X-Innspel-Tenant-Key', type: 'apiKey' }, {
            key: 'FeedbackTokenAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/ingest/handoffs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * RESERVED v2. The phone fetches the TV's context to show it, removable line by line (DD-05), and send as usual with handoffId. Unknown, expired or used → 404 handoff_invalid.
 */
export const handoffsGet = <ThrowOnError extends boolean = false>(options: Options<HandoffsGetData, ThrowOnError>): RequestResult<HandoffsGetResponses, HandoffsGetErrors, ThrowOnError> => (options.client ?? client).get<HandoffsGetResponses, HandoffsGetErrors, ThrowOnError>({
    security: [{ name: 'X-Innspel-Tenant-Key', type: 'apiKey' }, {
            key: 'FeedbackTokenAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/ingest/handoffs/{id}',
    ...options
});

/**
 * Accepts the invitation after the expectations step (DD-13, DD-32). The token in the path is single-use and ≤ 14 days; it must have been issued to the caller's subject — wrong subject, unknown, expired or used all give 404 invitation_invalid. A repeat from the same subject is idempotent (200 with the participation). The programme must be aapen or aktiv (409 invalid_status_transition), and not full (409 program_full). Declined first → 409 invitation_already_answered. Emits program.participant_joined.
 */
export const programsAccept = <ThrowOnError extends boolean = false>(options: Options<ProgramsAcceptData, ThrowOnError>): RequestResult<ProgramsAcceptResponses, ProgramsAcceptErrors, ThrowOnError> => (options.client ?? client).post<ProgramsAcceptResponses, ProgramsAcceptErrors, ThrowOnError>({
    security: [{ name: 'X-Innspel-Tenant-Key', type: 'apiKey' }, {
            key: 'FeedbackTokenAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/ingest/invitations/{token}/accept',
    ...options
});

/**
 * Declines the invitation — invitation_declined in the measurement model and status avslaatt in the panel. No reason is asked for (idea bank). Same 404 rule as accept. Accepted first → 409 invitation_already_answered: a no after a yes is «Gå ut» (Leave), not a decline. Addition beyond the brief's list: without it, status avslaatt does not exist.
 */
export const programsDecline = <ThrowOnError extends boolean = false>(options: Options<ProgramsDeclineData, ThrowOnError>): RequestResult<ProgramsDeclineResponses, ProgramsDeclineErrors, ThrowOnError> => (options.client ?? client).post<ProgramsDeclineResponses, ProgramsDeclineErrors, ThrowOnError>({
    security: [{ name: 'X-Innspel-Tenant-Key', type: 'apiKey' }, {
            key: 'FeedbackTokenAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/ingest/invitations/{token}/decline',
    ...options
});

/**
 * Known issues for screen and version — shown BEFORE the field in the bug track (DD-03, the differentiator). At most three cards, only status aktiv or fikset with appVersion ≤ fixedIn (DD-30), only visibleInWidget. Works anonymously. An empty list is a valid answer and gives no cards, not an empty state.
 */
export const knownIssuesList2 = <ThrowOnError extends boolean = false>(options?: Options<KnownIssuesList2Data, ThrowOnError>): RequestResult<KnownIssuesList2Responses, KnownIssuesList2Errors, ThrowOnError> => (options?.client ?? client).get<KnownIssuesList2Responses, KnownIssuesList2Errors, ThrowOnError>({
    security: [{ name: 'X-Innspel-Tenant-Key', type: 'apiKey' }, {
            key: 'FeedbackTokenAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/ingest/known-issues',
    ...options
});

/**
 * «Ja, jeg også» (Me too) (DD-29): creates a Submission with status kjent_feil, without text, which raises Reach without a new case. The card must be visible to the caller (otherwise 404 known_issue_not_found). With a token: one per (subject, knownIssue) — a repeat returns the existing one with 200. Anonymously: counts in anonymousCount. Replaces the brief's «POST submissions/{id}/confirm-known-issue», where {id} was ambiguous — here it is the known issue.
 */
export const knownIssuesConfirm = <ThrowOnError extends boolean = false>(options: Options<KnownIssuesConfirmData, ThrowOnError>): RequestResult<KnownIssuesConfirmResponses, KnownIssuesConfirmErrors, ThrowOnError> => (options.client ?? client).post<KnownIssuesConfirmResponses, KnownIssuesConfirmErrors, ThrowOnError>({
    security: [{ name: 'X-Innspel-Tenant-Key', type: 'apiKey' }, {
            key: 'FeedbackTokenAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/ingest/known-issues/{id}/confirm',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * «Gå ut» (Leave) — always visible in the tab (DD-36). The participation goes to trukket, the subject disappears from the segment in the same transaction, program.segment_changed and program.participant_withdrawn are emitted, and no further contacts are sent. Idempotent: already trukket gives 200. Addition beyond the brief's list: DD-36 requires it.
 */
export const programsWithdraw = <ThrowOnError extends boolean = false>(options: Options<ProgramsWithdrawData, ThrowOnError>): RequestResult<ProgramsWithdrawResponses, ProgramsWithdrawErrors, ThrowOnError> => (options.client ?? client).post<ProgramsWithdrawResponses, ProgramsWithdrawErrors, ThrowOnError>({
    security: [{ name: 'X-Innspel-Tenant-Key', type: 'apiKey' }, {
            key: 'FeedbackTokenAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/ingest/participations/{id}/withdraw',
    ...options
});

/**
 * Everything about beta programmes for the caller's subject — the SDK's programs.list(): own invitations (for the banner, DD-12), participations with task status (the tab), and follow-ups waiting for an answer. One call, because the SDK asks when the widget is opened and never in the background.
 */
export const programsListMine = <ThrowOnError extends boolean = false>(options?: Options<ProgramsListMineData, ThrowOnError>): RequestResult<ProgramsListMineResponses, ProgramsListMineErrors, ThrowOnError> => (options?.client ?? client).get<ProgramsListMineResponses, ProgramsListMineErrors, ThrowOnError>({
    security: [{ name: 'X-Innspel-Tenant-Key', type: 'apiKey' }, {
            key: 'FeedbackTokenAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/ingest/programs',
    ...options
});

/**
 * «Mine innspill» (My submissions) (DD-27, DD-41): the caller's own submissions, newest first, with status, promise basis and reply. Requires a token (401 feedback_token_required without one) — anonymous mode has no list. Known-issue confirmations are included (empty text, knownIssue set). Addition beyond the brief's list: the portal cannot hold ids locally.
 */
export const submissionsListMine = <ThrowOnError extends boolean = false>(options?: Options<SubmissionsListMineData, ThrowOnError>): RequestResult<SubmissionsListMineResponses, SubmissionsListMineErrors, ThrowOnError> => (options?.client ?? client).get<SubmissionsListMineResponses, SubmissionsListMineErrors, ThrowOnError>({
    security: [{ name: 'X-Innspel-Tenant-Key', type: 'apiKey' }, {
            key: 'FeedbackTokenAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/ingest/submissions',
    ...options
});

/**
 * The submission. Discriminated on type: feil can carry correlation and relatedKnownIssueId; onske cannot — such a field gives 400 unknown_field. The text is fully stored when 201 arrives; a screenshot is added afterwards via Attachments and can fail on its own (DD-42).
 *
 * Server-side: subject from the token (null without a token), context read by field name against the allow-list (unknown → 400 unknown_field, K5), text against the tenant's min/max (400 text_too_short / text_too_long), correlation against the declared kind (400 correlation_invalid), programId requires a token and an active participation (404 program_not_found otherwise). The same clientRef from the same subject within 24 h gives 200 with the existing one — the offline queue can safely retry.
 *
 * Status is always ny on 201. The receipt promises per track (DD-07); the promise text lives in the client.
 */
export const submissionsCreate = <ThrowOnError extends boolean = false>(options: Options<SubmissionsCreateData, ThrowOnError>): RequestResult<SubmissionsCreateResponses, SubmissionsCreateErrors, ThrowOnError> => (options.client ?? client).post<SubmissionsCreateResponses, SubmissionsCreateErrors, ThrowOnError>({
    security: [{ name: 'X-Innspel-Tenant-Key', type: 'apiKey' }, {
            key: 'FeedbackTokenAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/ingest/submissions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The submitter adds more to their own case («Legg til mer» (Add more) in «Mine innspill»). Not a reply to the reply and not a thread: the case keeps one reply, the addendum does not change status, and there is a cap of three.
 *
 * Requires a token (401 feedback_token_required without one). A case that belongs to another subject, is anonymous or exists at another tenant gives 404 submission_not_found. A closed case (statusType complete or closed) gives 409 submission_closed; three existing addenda give 409 addendum_limit_reached — both mean «send a new submission». The text against the tenant's limits (400 text_too_short / text_too_long). Rate limit per subject (429).
 *
 * Server-side: lastActivityAt is set, so the case is not marked «Ingen aktivitet på 4 uker» (No activity for 4 weeks), and the panel gets lastAddendumAt on the row. The text is submission text: never in telemetry, logs, e-mail or webhooks (CLAUDE.md), and it is deleted with the case on deletion per pseudonym (K11). The response is the updated view of the case.
 */
export const submissionsAddAddendum = <ThrowOnError extends boolean = false>(options: Options<SubmissionsAddAddendumData, ThrowOnError>): RequestResult<SubmissionsAddAddendumResponses, SubmissionsAddAddendumErrors, ThrowOnError> => (options.client ?? client).post<SubmissionsAddAddendumResponses, SubmissionsAddAddendumErrors, ThrowOnError>({
    security: [{ name: 'X-Innspel-Tenant-Key', type: 'apiKey' }, {
            key: 'FeedbackTokenAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/ingest/submissions/{id}/addenda',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Status for one of the caller's own submissions — the SDK's subjects.status(). Requires a token; a submission that belongs to another subject, or is anonymous, gives 404 submission_not_found. Anonymous submissions cannot be looked up: there is no identity to bind them to.
 */
export const submissionsStatus = <ThrowOnError extends boolean = false>(options: Options<SubmissionsStatusData, ThrowOnError>): RequestResult<SubmissionsStatusResponses, SubmissionsStatusErrors, ThrowOnError> => (options.client ?? client).get<SubmissionsStatusResponses, SubmissionsStatusErrors, ThrowOnError>({
    security: [{ name: 'X-Innspel-Tenant-Key', type: 'apiKey' }, {
            key: 'FeedbackTokenAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/ingest/submissions/{id}/status',
    ...options
});

/**
 * Completes a task with an outcome (fungerte · delvis · ikke). One completion per (participant, task) — 409 task_already_completed. submissionId must be the caller's own submission (404 submission_not_found otherwise). Emits task_completed in the measurement model; no webhook.
 */
export const programsCompleteTask = <ThrowOnError extends boolean = false>(options: Options<ProgramsCompleteTaskData, ThrowOnError>): RequestResult<ProgramsCompleteTaskResponses, ProgramsCompleteTaskErrors, ThrowOnError> => (options.client ?? client).post<ProgramsCompleteTaskResponses, ProgramsCompleteTaskErrors, ThrowOnError>({
    security: [{ name: 'X-Innspel-Tenant-Key', type: 'apiKey' }, {
            key: 'FeedbackTokenAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/v1/ingest/tasks/{id}/complete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The deletion receipt, with counts once it is completed. Scope subjects:delete.
 */
export const deletionsGet = <ThrowOnError extends boolean = false>(options: Options<DeletionsGetData, ThrowOnError>): RequestResult<DeletionsGetResponses, DeletionsGetErrors, ThrowOnError> => (options.client ?? client).get<DeletionsGetResponses, DeletionsGetErrors, ThrowOnError>({
    security: [{ name: 'X-Innspel-Api-Key', type: 'apiKey' }],
    url: '/v1/tenant/deletions/{id}',
    ...options
});

/**
 * The tenant confirms that the flag is ON (enabled = true) or OFF (false) for a pseudonym. The first confirmation takes the programme from aapen to aktiv. false after trukket removes «flagg ikke bekreftet av» (flag not confirmed off) (DD-36). Unknown participant → 404 participant_not_found. Scope programs:confirm.
 */
export const programsFlagConfirmed = <ThrowOnError extends boolean = false>(options: Options<ProgramsFlagConfirmedData, ThrowOnError>): RequestResult<ProgramsFlagConfirmedResponses, ProgramsFlagConfirmedErrors, ThrowOnError> => (options.client ?? client).post<ProgramsFlagConfirmedResponses, ProgramsFlagConfirmedErrors, ThrowOnError>({
    security: [{ name: 'X-Innspel-Api-Key', type: 'apiKey' }],
    url: '/v1/tenant/programs/{id}/participants/{sub}/flag-confirmed',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The frozen report — the same numbers as the panel and the tester's thank-you (DD-16). 404 report_not_found before avsluttet. Scope admin.
 */
export const programsReport = <ThrowOnError extends boolean = false>(options: Options<ProgramsReportData, ThrowOnError>): RequestResult<ProgramsReportResponses, ProgramsReportErrors, ThrowOnError> => (options.client ?? client).get<ProgramsReportResponses, ProgramsReportErrors, ThrowOnError>({
    security: [{ name: 'X-Innspel-Api-Key', type: 'apiKey' }],
    url: '/v1/tenant/programs/{id}/report',
    ...options
});

/**
 * The segment the tenant turns the flag on for: active participants' pseudonyms and nothing else (M3.3). ETag on the response; If-None-Match gives 304 when unchanged. A participant who leaves is gone from here in the same transaction as program.segment_changed is emitted (DD-36). Scope segment:read.
 */
export const programsSegment = <ThrowOnError extends boolean = false>(options: Options<ProgramsSegmentData, ThrowOnError>): RequestResult<ProgramsSegmentResponses, ProgramsSegmentErrors, ThrowOnError> => (options.client ?? client).get<ProgramsSegmentResponses, ProgramsSegmentErrors, ThrowOnError>({
    security: [{ name: 'X-Innspel-Api-Key', type: 'apiKey' }],
    url: '/v1/tenant/programs/{id}/segment',
    ...options
});

/**
 * Deletion per pseudonym (K11), triggered by the tenant when the user asks for it. Deletes text, attachments, correlation keys, replies, notes on the case, participations and follow-ups within 24 hours; the Reach count on affected cases stays, without a link. Responds 202 with a receipt immediately; completed is fetched via Deletions.get or arrives as subject.deleted. Idempotent: an unknown subject also gives 202 with a zero count — answering 404 would confirm who has submitted. Scope subjects:delete.
 */
export const subjectsRemove = <ThrowOnError extends boolean = false>(options: Options<SubjectsRemoveData, ThrowOnError>): RequestResult<SubjectsRemoveResponses, SubjectsRemoveErrors, ThrowOnError> => (options.client ?? client).delete<SubjectsRemoveResponses, SubjectsRemoveErrors, ThrowOnError>({
    security: [{ name: 'X-Innspel-Api-Key', type: 'apiKey' }],
    url: '/v1/tenant/subjects/{sub}',
    ...options
});

/**
 * Status change from the tenant's tooling (M1.4). Follows the state machine (409 invalid_status_transition); levert in the bug track requires fixedIn (422). Emits submission.status_changed as usual — the submitter gets the same promise regardless of who moved the case. Scope admin. In the contract because M1.4 names it; built there.
 */
export const submissionsUpdateStatus = <ThrowOnError extends boolean = false>(options: Options<SubmissionsUpdateStatusData, ThrowOnError>): RequestResult<SubmissionsUpdateStatusResponses, SubmissionsUpdateStatusErrors, ThrowOnError> => (options.client ?? client).patch<SubmissionsUpdateStatusResponses, SubmissionsUpdateStatusErrors, ThrowOnError>({
    security: [{ name: 'X-Innspel-Api-Key', type: 'apiKey' }],
    url: '/v1/tenant/submissions/{id}/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
